import React, { useState, useEffect, useRef, useMemo } from 'react';
import logo from '../logo_blade.png';
import AgendamentoManual from './AgendamentoManual';
import DetalhesAgendamento from './DetalhesAgendamento';
import PerfilBarbearia from './PerfilBarbearia';
import { performLogout } from '../hooks/useSessionPersistence';
import { auth, db } from '../services/firebase';
import { collection, query, where, onSnapshot, addDoc, doc, getDoc, updateDoc, writeBatch } from 'firebase/firestore';
import { isPendenteExpirado } from '../services/agendamentoSlot';

const meses = ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'];
const DIAS_ABV = ['Dom','Seg','Ter','Qua','Qui','Sex','Sáb'];
// Lista completa de slots 30 em 30 min cobrindo 24h
const HORARIOS = (() => {
  const r = [];
  for (let h = 0; h <= 23; h++) {
    r.push(`${String(h).padStart(2,'0')}:00`);
    r.push(`${String(h).padStart(2,'0')}:30`);
  }
  return r;
})();

function getDiasSemana(mes) {
  const ano = new Date().getFullYear();
  const mi = meses.indexOf(mes);
  const total = new Date(ano, mi + 1, 0).getDate();
  const dias = [];
  for (let d = 1; d <= total; d++) {
    const dt = new Date(ano, mi, d);
    dias.push({ dia: DIAS_ABV[dt.getDay()], num: String(d).padStart(2, '0') });
  }
  return dias;
}

function parsePreco(p) {
  if (!p) return 0;
  return parseFloat(p.toString().replace(/[^\d.,]/g, '').replace(',', '.')) || 0;
}

function fmtR(v) {
  return 'R$ ' + v.toFixed(2).replace('.', ',');
}

function relativeTime(iso) {
  if (!iso) return '';
  const diff = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'agora';
  if (mins < 60) return `há ${mins}min`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `há ${hrs}h`;
  const days = Math.floor(hrs / 24);
  if (days < 30) return `há ${days}d`;
  return new Date(iso).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
}

function fmtApptDia(a) {
  const mi = meses.indexOf(a.mes || '');
  if (mi === -1) return `${a.dia || '?'}`;
  const ano = new Date().getFullYear();
  const hoje = new Date();
  const dt = new Date(ano, mi, parseInt(a.dia || '0'));
  const diff = Math.floor((dt - new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate())) / 86400000);
  if (diff === 0) return 'Hoje';
  if (diff === 1) return 'Amanhã';
  if (diff === -1) return 'Ontem';
  return `${a.dia}/${String(mi + 1).padStart(2, '0')}`;
}

function iniciais(nome) {
  if (!nome) return '?';
  const p = nome.trim().split(' ');
  return p.length >= 2 ? (p[0][0] + p[1][0]).toUpperCase() : p[0].substring(0, 2).toUpperCase();
}

function Av({ nome, foto, size = 34, bg = '#2d4a2d', col = '#7bc47b' }) {
  return (
    <div style={{ width: size, height: size, borderRadius: '50%', backgroundColor: bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: size * 0.35, fontWeight: '600', color: col, flexShrink: 0, overflow: 'hidden' }}>
      {foto
        ? <img src={foto} alt={nome} style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={e => e.target.style.display = 'none'} />
        : iniciais(nome)}
    </div>
  );
}


function PainelBarbearia({ onVoltar, onLogout, abaInicial = 'home', cfgTabInicial = 'barbeiros' }) {
  const hoje = new Date();
  const nomeMesHoje = meses[hoje.getMonth()];
  const diaHoje = String(hoje.getDate()).padStart(2, '0');
  const agoraMins = hoje.getHours() * 60 + hoje.getMinutes();

  // ── Navegação ──
  const [aba, setAba] = useState(abaInicial);
  const [homeTab, setHomeTab] = useState('resumo');
  const [activityTab, setActivityTab] = useState('proximos');
  const [extTab, setExtTab] = useState('diario');
  const [cfgTab, setCfgTab] = useState(cfgTabInicial);
  const [clienteDetalhe, setClienteDetalhe] = useState(null);

  // ── Dados da barbearia ──
  const [barbearia, setBarbearia] = useState(null);
  const [mostrarPerfil, setMostrarPerfil] = useState(false);

  // ── Agenda ──
  const [mesAtivo, setMesAtivo] = useState(nomeMesHoje);
  const [diaAtivo, setDiaAtivo] = useState(diaHoje);
  const [filtroBarbeiro, setFiltroBarbeiro] = useState('todos');
  const [agendamentos, setAgendamentos] = useState([]);
  const [carregandoAgenda, setCarregandoAgenda] = useState(true);

  // ── Extrato ──
  const [extratoData, setExtratoData] = useState(new Date());
  const [extratoMes, setExtratoMes] = useState(new Date());
  const [filtroExtBarbeiro, setFiltroExtBarbeiro] = useState('todos');
  const [rawAgends, setRawAgends] = useState([]);     // agendamentos crus (sem PII de contato)
  const [contatos, setContatos] = useState({});       // { [agendamentoId]: { clienteNome, clienteTelefone } }
  const [agendsMensais, setAgendsMensais] = useState([]);

  // ── Modais ──
  const [slotSelecionado, setSlotSelecionado] = useState(null);
  const [detalhesSelecionado, setDetalhesSelecionado] = useState(null);
  const [modal, setModal] = useState(null);

  const diaRef = useRef(null);
  const timelineRef = useRef(null);
  const [modalBarb, setModalBarb] = useState('');
  const [confirmBloqueio, setConfirmBloqueio] = useState(null);
  const [faseBloqueio, setFaseBloqueio] = useState(1);
  const [bloqueioHorarios, setBloqueioHorarios] = useState(null);
  const [novoAgendToast, setNovoAgendToast] = useState(null);
  const prevAgendsIds = useRef(null);
  const [salvandoConfig, setSalvandoConfig] = useState(false);
  // Estado por tipo de promoção (cada um independente)
  const [promSimples, setPromSimples] = useState({ ativa: false, desconto: 0, texto: '' });
  const [promDias, setPromDias]       = useState({ ativa: false, desconto: 10, diasSemana: [], texto: '' });
  const [promFidelidade, setPromFidelidade] = useState({ ativa: false, fidelidadeMeta: 10, texto: '' });
  const mesIdx = meses.indexOf(mesAtivo);
  const diasSemana = getDiasSemana(mesAtivo);
  const nomeBarbearia = barbearia?.nome || '';
  const barbeirosObjetos = barbearia?.barbeiros || [];
  const barbeirosLista = barbeirosObjetos.map(b => b.nome).filter(Boolean);
  const servicosLista = barbearia?.servicos || [];

  // ── Effects ──

  useEffect(() => {
    const uid = auth.currentUser?.uid;
    if (!uid) return;
    getDoc(doc(db, 'barbearias', uid)).then(snap => {
      if (snap.exists()) {
        const data = snap.data();
        setBarbearia({ uid, ...data });
        // Carregar promoções — suporta formato novo (sub-objetos) e formato legado
        const p = data.promocao || {};
        if (p.simples !== undefined || p.dias !== undefined || p.fidelidade !== undefined) {
          // Formato novo
          setPromSimples(p.simples || { ativa: false, desconto: 0, texto: '' });
          setPromDias(p.dias || { ativa: false, desconto: 10, diasSemana: [], texto: '' });
          setPromFidelidade(p.fidelidade || { ativa: false, fidelidadeMeta: 10, texto: '' });
        } else if (p.ativa) {
          // Migrar formato legado para o novo
          const tipo = p.tipo || 'simples';
          if (tipo === 'simples') setPromSimples({ ativa: true, desconto: p.desconto || 0, texto: p.texto || '' });
          if (tipo === 'dias')    setPromDias({ ativa: true, desconto: p.desconto || 10, diasSemana: p.diasSemana || [], texto: p.texto || '' });
          if (tipo === 'fidelidade') setPromFidelidade({ ativa: true, fidelidadeMeta: p.fidelidadeMeta || 10, texto: p.texto || '' });
        }
      }
    });
    if (window.location.hostname !== 'localhost' && uid) {
      window.OneSignalDeferred = window.OneSignalDeferred || [];
      window.OneSignalDeferred.push((OneSignal) => {
        OneSignal.Notifications.requestPermission().catch(() => {});
        OneSignal.User.addTag('barbeariaId', uid);
        OneSignal.User.PushSubscription.optIn().catch(() => {});
      });
    }
  }, []);

  async function toggleAprovacao(valor) {
    const uid = auth.currentUser?.uid;
    if (!uid) return;
    setSalvandoConfig(true);
    await updateDoc(doc(db, 'barbearias', uid), { exigeAprovacao: valor });
    setBarbearia(prev => ({ ...prev, exigeAprovacao: valor }));
    setSalvandoConfig(false);
  }

  // Salva o estado completo das três promoções no Firestore
  async function salvarTodasPromocoes(simples, dias, fidelidade) {
    const uid = auth.currentUser?.uid;
    if (!uid) return;
    setSalvandoConfig(true);
    const novaPromocao = { simples, dias, fidelidade };
    await updateDoc(doc(db, 'barbearias', uid), { promocao: novaPromocao });
    setBarbearia(prev => ({ ...prev, promocao: novaPromocao }));
    setSalvandoConfig(false);
  }

  async function toggleTipo(tipo, valor) {
    const novaSimples     = tipo === 'simples'    ? { ...promSimples, ativa: valor }    : promSimples;
    const novaDias        = tipo === 'dias'        ? { ...promDias, ativa: valor }        : promDias;
    const novaFidelidade  = tipo === 'fidelidade'  ? { ...promFidelidade, ativa: valor }  : promFidelidade;
    setPromSimples(novaSimples);
    setPromDias(novaDias);
    setPromFidelidade(novaFidelidade);
    await salvarTodasPromocoes(novaSimples, novaDias, novaFidelidade);
  }

  async function salvarTipo(tipo) {
    await salvarTodasPromocoes(promSimples, promDias, promFidelidade);
  }

  // UID da barbearia autenticada
  const barbeariaUid = auth.currentUser?.uid;

  // Real-time: todos os agendamentos da barbearia (filtra dia em memória)
  useEffect(() => {
    if (!barbeariaUid) return;
    setCarregandoAgenda(true);
    const q = query(
      collection(db, 'agendamentos'),
      where('barbeariaId', '==', barbeariaUid)
    );
    return onSnapshot(q, snap => {
      const todos = snap.docs.map(d => ({ id: d.id, ...d.data() }));

      // Detecta novo agendamento vindo do app (não manual, não bloqueado)
      if (prevAgendsIds.current !== null) {
        const novos = todos.filter(a =>
          (a.status === 'confirmado' || a.status === 'pendente') &&
          a.tipo !== 'manual' &&
          a.tipo !== 'bloqueado' &&
          !prevAgendsIds.current.has(a.id)
        );
        if (novos.length > 0) {
          const mais = novos.sort((a, b) => (b.criadoEm || '').localeCompare(a.criadoEm || ''))[0];
          setNovoAgendToast(mais);
          setTimeout(() => setNovoAgendToast(null), 6000);
        }
      }
      prevAgendsIds.current = new Set(todos.map(a => a.id));

      setRawAgends(todos);
      setCarregandoAgenda(false);
    });
  }, [barbeariaUid]); // eslint-disable-line react-hooks/exhaustive-deps

  // Expira pedidos pendentes cujo horário já começou: marca como cancelado para liberar
  // o slot e tirá-los da fila de aprovação. A barbearia é dona dos docs, então pode escrever.
  useEffect(() => {
    const agora = new Date();
    rawAgends
      .filter(a => a.status === 'pendente' && isPendenteExpirado(a, agora))
      .forEach(a => {
        updateDoc(doc(db, 'agendamentos', a.id), { status: 'cancelado', expirado: true }).catch(() => {});
      });
  }, [rawAgends]);

  // Real-time: docs de contato (PII) da barbearia — mesclados em memória nos agendamentos
  useEffect(() => {
    if (!barbeariaUid) return;
    const q = query(
      collection(db, 'atendimentos_contato'),
      where('barbeariaId', '==', barbeariaUid)
    );
    return onSnapshot(q, snap => {
      const mapa = {};
      snap.docs.forEach(d => {
        const { clienteNome, clienteTelefone } = d.data();
        mapa[d.id] = { clienteNome, clienteTelefone };
      });
      setContatos(mapa);
    });
  }, [barbeariaUid]);

  // Agendamentos com a PII de contato mesclada (retrocompatível: docs antigos têm PII inline)
  const todosAgends = useMemo(
    () => rawAgends.map(a => contatos[a.id] ? { ...a, ...contatos[a.id] } : a),
    [rawAgends, contatos]
  );

  // Filtra agendamentos do dia ativo em memória (reativo a todosAgends + diaAtivo + mesAtivo)
  useEffect(() => {
    setAgendamentos(
      todosAgends.filter(a => a.dia === diaAtivo && (a.mes === mesAtivo || !a.mes) && a.status !== 'cancelado')
    );
  }, [todosAgends, diaAtivo, mesAtivo]);

  // Filtro mensal
  useEffect(() => {
    const ano = extratoMes.getFullYear();
    const mes = extratoMes.getMonth();
    setAgendsMensais(todosAgends.filter(a => {
      if (a.status === 'bloqueado') return false;
      // Novo formato: mes como nome (ex: 'Maio') e ano implícito
      if (a.dia && a.mes) return meses.indexOf(a.mes) === mes;
      // Legado: criadoEm
      if (a.criadoEm) { const d = new Date(a.criadoEm); return d.getFullYear() === ano && d.getMonth() === mes; }
      return false;
    }));
  }, [todosAgends, extratoMes]);

  useEffect(() => {
    if (diaRef.current) {
      diaRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }, [mesAtivo, aba]);

  useEffect(() => {
    if (aba === 'agenda') {
      setTimeout(() => {
        timelineRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 200);
    }
  }, [aba]);

  // ── Helpers ──

  function getSlot(barbeiro, horario) {
    return agendamentos.find(a => a.barbeiro === barbeiro && a.horario === horario);
  }

  function getSlotsHorario(horario) {
    return agendamentos.filter(a => a.horario === horario);
  }

  function isPassado(horario) {
    if (diaAtivo !== diaHoje || mesAtivo !== nomeMesHoje) return false;
    const [h, m] = horario.split(':').map(Number);
    return (h * 60 + m + 30) <= agoraMins;
  }

  function isAtual(horario) {
    if (diaAtivo !== diaHoje || mesAtivo !== nomeMesHoje) return false;
    const [h, m] = horario.split(':').map(Number);
    const s = h * 60 + m;
    return agoraMins >= s && agoraMins < s + 30;
  }

  function calcFin(lista) {
    const validos = lista.filter(a => a.status !== 'bloqueado');
    const bruto = validos.reduce((s, a) => s + parsePreco(a.preco), 0);
    const taxa = bruto * 0.1;
    return { bruto, taxa, liquido: bruto - taxa, count: validos.length };
  }

  function getDiaSemanaAtivo() {
    const ano = new Date().getFullYear();
    const dt = new Date(ano, meses.indexOf(mesAtivo), parseInt(diaAtivo));
    return DIAS_ABV[dt.getDay()]; // 'Dom','Seg','Ter','Qua','Qui','Sex','Sáb'
  }

  function getHorariosParaBarbeiro(barb, diaSemana) {
    if (!barb) return HORARIOS;
    const hp = barb.horariosPorDia;
    if (hp) {
      const periodos = hp[diaSemana] || [];
      if (!periodos.length) return [];
      const slots = new Set();
      periodos.forEach(({ inicio, fim }) => {
        const [ih, im] = inicio.split(':').map(Number);
        const [fh, fm] = fim.split(':').map(Number);
        const iMin = ih * 60 + im, fMin = fh * 60 + fm;
        HORARIOS.forEach(h => {
          const [hh, mm] = h.split(':').map(Number);
          if (hh * 60 + mm >= iMin && hh * 60 + mm <= fMin) slots.add(h);
        });
      });
      return HORARIOS.filter(h => slots.has(h));
    }
    // Modelo legado
    const trabalha = (barb.diasTrabalho || []).includes(diaSemana);
    if (!trabalha) return [];
    const [ih, im] = (barb.horaInicio || '09:00').split(':').map(Number);
    const [fh, fm] = (barb.horaFim || '19:00').split(':').map(Number);
    const iMin = ih * 60 + im, fMin = fh * 60 + fm;
    return HORARIOS.filter(h => {
      const [hh, mm] = h.split(':').map(Number);
      return hh * 60 + mm >= iMin && hh * 60 + mm <= fMin;
    });
  }

  // Home sempre usa dados de HOJE (independente do dia selecionado na agenda)
  const agendamentosHoje = todosAgends.filter(a => a.dia === diaHoje && (a.mes === nomeMesHoje || !a.mes));
  const finHoje = calcFin(agendamentosHoje);

  // Extrato: agendamentos do dia selecionado no extrato
  const agendsDiaExtrato = todosAgends.filter(a => {
    if (a.status === 'bloqueado') return false;
    const diaExt = String(extratoData.getDate()).padStart(2, '0');
    const mesExt = meses[extratoData.getMonth()];
    // Novo formato: dia + mes
    if (a.dia && a.mes) return a.dia === diaExt && a.mes === mesExt;
    // Legado: criadoEm
    if (a.criadoEm) return new Date(a.criadoEm).toDateString() === extratoData.toDateString();
    return false;
  });
  const agendsDiaFilt = filtroExtBarbeiro === 'todos' ? agendsDiaExtrato : agendsDiaExtrato.filter(a => a.barbeiro === filtroExtBarbeiro);
  const agendsMensFilt = filtroExtBarbeiro === 'todos' ? agendsMensais : agendsMensais.filter(a => a.barbeiro === filtroExtBarbeiro);
  const finExtDia = calcFin(agendsDiaFilt);
  const finExtMes = calcFin(agendsMensFilt);

  // Agrupar por hora para extrato diário
  const porHora = {};
  agendsDiaFilt.forEach(a => {
    const h = (a.horario || '00:00').substring(0, 2) + 'h';
    if (!porHora[h]) porHora[h] = [];
    porHora[h].push(a);
  });

  // Calendário mensal — receita por dia (usa campo dia quando disponível)
  const calData = {};
  agendsMensFilt.forEach(a => {
    const k = a.dia || (a.criadoEm ? String(new Date(a.criadoEm).getDate()).padStart(2, '0') : null);
    if (k) calData[k] = (calData[k] || 0) + parsePreco(a.preco) * 0.9;
  });

  // Resumo mensal
  const diasComAgend = Object.keys(calData).length;
  const ticketMedio = finExtMes.count > 0 ? finExtMes.bruto / finExtMes.count : 0;
  const mediaDiaria = diasComAgend > 0 ? finExtMes.count / diasComAgend : 0;
  const diaMaisMovim = Object.entries(
    agendsMensFilt.reduce((acc, a) => {
      const k = new Date(a.criadoEm).toLocaleDateString('pt-BR', { weekday: 'long' });
      acc[k] = (acc[k] || 0) + 1;
      return acc;
    }, {})
  ).sort((a, b) => b[1] - a[1])[0]?.[0] || '—';

  // Clientes de todos os agendamentos (suporta clienteNome novo e cliente legado)
  const clientesMap = {};
  todosAgends.filter(a => a.status !== 'bloqueado' && (a.clienteNome || a.cliente)).forEach(a => {
    const nomeCliente = a.clienteNome || a.cliente || '';
    const tel = a.clienteTelefone || a.telefone || '';
    const key = tel || nomeCliente;
    if (!clientesMap[key]) clientesMap[key] = { nome: nomeCliente, telefone: tel, visitas: 0, historico: [] };
    clientesMap[key].visitas++;
    clientesMap[key].historico.push(a);
  });
  const clientesList = Object.values(clientesMap).sort((a, b) => b.visitas - a.visitas);

  // Próximo cliente — sempre de hoje, independente do dia ativo na agenda
  const proximoCliente = [...agendamentosHoje]
    .filter(a => ['confirmado', 'pendente'].includes(a.status))
    .filter(a => { const [h, m] = (a.horario || '00:00').split(':').map(Number); return h * 60 + m >= agoraMins; })
    .sort((a, b) => (a.horario || '').localeCompare(b.horario || ''))[0];

  // ── Atividades recentes (3 abas) ──
  const _agora = hoje;
  const _toTs = a => {
    const mi = meses.indexOf(a.mes || '');
    if (mi === -1) return 0;
    const [h, m] = (a.horario || '00:00').split(':').map(Number);
    return new Date(_agora.getFullYear(), mi, parseInt(a.dia || '0'), h, m).getTime();
  };
  const atividadeProximos = todosAgends
    .filter(a => (a.status === 'confirmado' || a.status === 'pendente') && _toTs(a) > _agora.getTime())
    .sort((a, b) => _toTs(a) - _toTs(b));
  const atividadeAgendamentos = todosAgends
    .filter(a => a.status !== 'bloqueado' && a.status !== 'cancelado')
    .sort((a, b) => (b.criadoEm || '').localeCompare(a.criadoEm || ''));
  const atividadeCancelamentos = todosAgends
    .filter(a => a.status === 'cancelado')
    .sort((a, b) => (b.criadoEm || '').localeCompare(a.criadoEm || ''));
  // Só pendentes que ainda não começaram — os que passaram do horário expiram
  const atividadePendentes = todosAgends
    .filter(a => a.status === 'pendente' && !isPendenteExpirado(a, _agora))
    .sort((a, b) => _toTs(a) - _toTs(b));

  // Confirma um agendamento pendente direto da lista (aprovação rápida)
  async function confirmarPendente(e, ag) {
    e.stopPropagation();
    try {
      await updateDoc(doc(db, 'agendamentos', ag.id), { status: 'confirmado' });
      // Push para o cliente (só agendamentos do app têm clienteId)
      if (ag.clienteId) {
        fetch('/api/notify', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            clienteId: ag.clienteId,
            titulo: 'Agendamento confirmado! ✅',
            mensagem: `${ag.barbearia || 'A barbearia'} confirmou seu horário de ${parseInt(ag.dia)} de ${ag.mes} às ${ag.horario}.`,
          }),
        }).catch(() => {});
      }
    } catch (err) {
      console.error('Erro ao confirmar agendamento:', err);
    }
  }

  // ── Salvar ──
  async function salvarAgendamento(dados) {
    if (dados.status === 'confirmado') {
      const mesDados = dados.mes || mesAtivo;
      const conflito = todosAgends.find(a =>
        a.barbeiro === dados.barbeiro &&
        a.horario === dados.horario &&
        a.dia === dados.dia &&
        (a.mes === mesDados || !a.mes) &&
        a.status !== 'cancelado'
      );
      if (conflito) {
        setSlotSelecionado(null);
        setModal({ tipo: 'conflito-manual', dados: { barbeiro: dados.barbeiro, horario: dados.horario } });
        return;
      }
    }
    try {
      const uid = auth.currentUser?.uid;
      const criadoEm = new Date().toISOString();
      // PII de contato (cliente/telefone do walk-in) vai para coleção protegida — fora do agendamento público
      const { cliente, telefone, ...rest } = dados;
      const batch = writeBatch(db);
      const ref = doc(collection(db, 'agendamentos'));
      // mes garante que Horarios.js filtre corretamente por mês
      batch.set(ref, { mes: mesAtivo, ...rest, barbearia: nomeBarbearia, barbeariaId: uid, criadoEm });
      if (cliente || telefone) {
        batch.set(doc(db, 'atendimentos_contato', ref.id), {
          barbeariaId: uid, clienteId: '', clienteNome: cliente || '', clienteTelefone: telefone || '', criadoEm,
        });
      }
      await batch.commit();
      setSlotSelecionado(null);
    } catch (e) { console.error(e); }
  }

  async function salvarMultiplos(lista) {
    try {
      const uid = auth.currentUser?.uid;
      const criadoEm = new Date().toISOString();
      const batch = writeBatch(db);
      lista.forEach(d => {
        const { cliente, telefone, ...rest } = d;
        const ref = doc(collection(db, 'agendamentos'));
        batch.set(ref, { mes: d.mes || mesAtivo, ...rest, barbearia: nomeBarbearia, barbeariaId: uid, criadoEm });
        if (cliente || telefone) {
          batch.set(doc(db, 'atendimentos_contato', ref.id), {
            barbeariaId: uid, clienteId: '', clienteNome: cliente || '', clienteTelefone: telefone || '', criadoEm,
          });
        }
      });
      await batch.commit();
      setSlotSelecionado(null);
    } catch (e) { console.error(e); }
  }

  async function salvarBloqueiosHorarios(barbeiro, dia, horariosList, conflitosParaCancelar) {
    try {
      const uid = auth.currentUser?.uid;
      if (conflitosParaCancelar?.length > 0) {
        await Promise.all(conflitosParaCancelar.map(c =>
          updateDoc(doc(db, 'agendamentos', c.id), { status: 'cancelado' })
        ));
        // Avisa por push os clientes afetados (só agendamentos do app têm clienteId)
        conflitosParaCancelar.forEach(c => {
          if (!c.clienteId) return;
          fetch('/api/notify', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              clienteId: c.clienteId,
              titulo: 'Agendamento cancelado',
              mensagem: `${nomeBarbearia || 'A barbearia'} cancelou seu horário de ${parseInt(c.dia)} de ${c.mes || mesAtivo} às ${c.horario}.`,
            }),
          }).catch(() => {});
        });
      }
      await Promise.all(horariosList.map(h =>
        addDoc(collection(db, 'agendamentos'), {
          barbeiro, horario: h, dia, mes: mesAtivo,
          barbearia: nomeBarbearia, barbeariaId: uid,
          clienteId: uid,
          servico: 'Bloqueado', preco: 'R$ 0',
          status: 'bloqueado', tipo: 'manual',
          criadoEm: new Date().toISOString()
        })
      ));
      setBloqueioHorarios(null);
    } catch (e) { console.error(e); }
  }

  function abrirHorario(barbeiro, horario) {
    const slot = getSlot(barbeiro, horario);
    if (slot) { setDetalhesSelecionado(slot); return; }
    if (!isPassado(horario)) { setModalBarb(barbeiro); setModal({ tipo: 'horario-livre', dados: { barbeiro, horario } }); }
  }

  // ── ESTILOS ──
  const ST = {
    card: { backgroundColor: '#181818', border: '0.5px solid #252525', borderRadius: '12px', padding: '12px 14px', marginBottom: '10px' },
    greenCard: { backgroundColor: '#1a2a1a', border: '0.5px solid #2d4a2d', borderRadius: '12px', padding: '14px', marginBottom: '10px' },
    row: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
    pill: (on) => ({ padding: '5px 12px', borderRadius: '20px', fontSize: '11px', fontWeight: '500', border: `0.5px solid ${on ? '#2d4a2d' : '#333'}`, backgroundColor: on ? '#2d4a2d' : 'transparent', color: on ? '#7bc47b' : '#888', cursor: 'pointer', fontFamily: 'Arial, sans-serif' }),
    stb: { display: 'flex', gap: '1px', backgroundColor: '#1a1a1a', borderRadius: '10px', padding: '3px', marginBottom: '12px' },
    stbBtn: (on) => ({ flex: 1, padding: '5px 2px', fontSize: '10px', fontWeight: '600', textAlign: 'center', borderRadius: '7px', color: on ? '#7bc47b' : '#777', cursor: 'pointer', border: 'none', backgroundColor: on ? '#2d4a2d' : 'transparent', fontFamily: 'Arial, sans-serif' }),
    tag: (bg, col, brd) => ({ display: 'inline-block', backgroundColor: bg, color: col, border: `0.5px solid ${brd}`, borderRadius: '20px', padding: '2px 7px', fontSize: '10px', fontWeight: '600' }),
    inp: { width: '100%', padding: '11px 12px', borderRadius: '9px', border: '0.5px solid #2a2a2a', backgroundColor: '#1a1a1a', color: '#e8e8e8', fontSize: '13px', boxSizing: 'border-box', outline: 'none', fontFamily: 'Arial, sans-serif' },
    bbBtn: (on) => ({ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2px', padding: '8px 4px 10px', border: 'none', backgroundColor: 'transparent', cursor: 'pointer', color: on ? '#7bc47b' : '#555' }),
  };

  function fecharModal() { setModal(null); }

  function abrirLembrete(a) {
    const tel = (a.clienteTelefone || a.telefone || '').replace(/\D/g, '');
    if (!tel) return;
    const nome = (a.clienteNome || a.cliente || 'Cliente').split(' ')[0];
    const msg = `Olá ${nome}! 😊 Lembrando que amanhã você tem horário marcado na *${nomeBarbearia}*.\n\n📅 ${parseInt(a.dia)} de ${a.mes}\n⏰ ${a.horario}\n✂️ ${a.barbeiro} — ${a.servico}\n\nTe esperamos! 💈`;
    window.open(`https://wa.me/${tel}?text=${encodeURIComponent(msg)}`, '_blank');
  }

  // ── MODAL INLINE ──
  function renderModal() {
    if (!modal) return null;
    const { tipo, dados } = modal;
    let body = null;

    if (tipo === 'breakdown-dia') {
      const f = finExtDia;
      body = <>
        <div style={{ fontSize: '11px', fontWeight: '700', color: '#7bc47b', letterSpacing: '1px', textTransform: 'uppercase', marginBottom: '14px' }}>Detalhamento · {extratoData.toLocaleDateString('pt-BR')}</div>
        {[{ l: 'Receita bruta', v: fmtR(f.bruto), c: '#e8e8e8' }, { l: 'Serviços financeiros', v: fmtR(0), c: '#555', sm: true }, { l: 'Taxa de conveniência BLADE', v: `-${fmtR(f.taxa)}`, c: '#555', sm: true }].map((r, i) => (
          <div key={i} style={{ ...ST.row, padding: '7px 0', borderBottom: '0.5px solid #1e1e1e' }}>
            <span style={{ fontSize: '12px', color: '#aeaeae' }}>{r.l}</span>
            <span style={{ fontSize: r.sm ? '11px' : '13px', color: r.c, fontWeight: r.sm ? '400' : '500' }}>{r.v}</span>
          </div>
        ))}
        <div style={{ ...ST.row, paddingTop: '10px', borderTop: '0.5px solid #2d4a2d', marginTop: '4px' }}>
          <span style={{ fontSize: '13px', color: '#7bc47b', fontWeight: '600' }}>Total líquido</span>
          <span style={{ fontSize: '18px', color: '#7bc47b', fontWeight: '700' }}>{fmtR(f.liquido)}</span>
        </div>
      </>;
    }

    if (tipo === 'breakdown-mes') {
      const f = finExtMes;
      body = <>
        <div style={{ fontSize: '11px', fontWeight: '700', color: '#7bc47b', letterSpacing: '1px', textTransform: 'uppercase', marginBottom: '14px' }}>Detalhamento · {extratoMes.toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' })}</div>
        {[{ l: 'Receita bruta', v: fmtR(f.bruto), c: '#e8e8e8' }, { l: 'Serviços financeiros', v: fmtR(0), c: '#555', sm: true }, { l: 'Taxa de conveniência BLADE', v: `-${fmtR(f.taxa)}`, c: '#555', sm: true }].map((r, i) => (
          <div key={i} style={{ ...ST.row, padding: '7px 0', borderBottom: '0.5px solid #1e1e1e' }}>
            <span style={{ fontSize: '12px', color: '#aeaeae' }}>{r.l}</span>
            <span style={{ fontSize: r.sm ? '11px' : '13px', color: r.c, fontWeight: r.sm ? '400' : '500' }}>{r.v}</span>
          </div>
        ))}
        <div style={{ ...ST.row, paddingTop: '10px', borderTop: '0.5px solid #2d4a2d', marginTop: '4px' }}>
          <span style={{ fontSize: '13px', color: '#7bc47b', fontWeight: '600' }}>Total líquido</span>
          <span style={{ fontSize: '18px', color: '#7bc47b', fontWeight: '700' }}>{fmtR(f.liquido)}</span>
        </div>
      </>;
    }

    if (tipo === 'hora-detalhe') {
      const { hora, items } = dados;
      const tot = items.reduce((s, a) => s + parsePreco(a.preco), 0);
      body = <>
        <div style={{ fontSize: '11px', fontWeight: '700', color: '#7bc47b', letterSpacing: '1px', textTransform: 'uppercase', marginBottom: '14px' }}>{hora} · {items.length} atendimento{items.length !== 1 ? 's' : ''}</div>
        {items.map((a, i) => (
          <div key={i} style={{ ...ST.row, padding: '7px 0', borderBottom: '0.5px solid #1e1e1e' }}>
            <div>
              <div style={{ fontSize: '13px', color: '#e8e8e8', fontWeight: '500' }}>{a.clienteNome || a.cliente || '—'}</div>
              <div style={{ fontSize: '11px', color: '#aeaeae', marginTop: '1px' }}>{a.servico} · {a.barbeiro}</div>
            </div>
            <span style={{ fontSize: '13px', color: '#7bc47b', fontWeight: '600' }}>{fmtR(parsePreco(a.preco))}</span>
          </div>
        ))}
        <div style={{ ...ST.row, paddingTop: '10px', borderTop: '0.5px solid #2d4a2d', marginTop: '4px' }}>
          <span style={{ fontSize: '12px', color: '#aeaeae' }}>Total da hora</span>
          <span style={{ fontSize: '16px', color: '#7bc47b', fontWeight: '700' }}>{fmtR(tot)}</span>
        </div>
      </>;
    }

    if (tipo === 'horario-livre') {
      const { horario } = dados;
      const diaSemana = getDiaSemanaAtivo();
      const barbsDisponiveis = barbeirosLista.filter(nome => {
        const barb = barbeirosObjetos.find(b => b.nome === nome);
        if (!getHorariosParaBarbeiro(barb, diaSemana).includes(horario)) return false;
        // Exclui barbeiros que já têm qualquer slot nesse horário (bloqueado ou confirmado)
        return !agendamentos.some(a => a.barbeiro === nome && a.horario === horario && a.status !== 'cancelado');
      });
      const listaBarbeiros = barbsDisponiveis.length > 0 ? barbsDisponiveis : [];
      const barbSelecionado = (modalBarb && listaBarbeiros.includes(modalBarb)) ? modalBarb : listaBarbeiros[0] || '';
      if (listaBarbeiros.length === 0) {
        body = <>
          <div style={{ fontSize: '11px', fontWeight: '700', color: '#e05555', letterSpacing: '1px', textTransform: 'uppercase', marginBottom: '12px' }}>Horário indisponível · {horario}</div>
          <p style={{ fontSize: '13px', color: '#aeaeae', lineHeight: '1.6', marginBottom: '16px' }}>
            Todos os barbeiros estão bloqueados ou ocupados neste horário.
          </p>
          <button onClick={fecharModal} style={{ width: '100%', padding: '10px', borderRadius: '9px', border: '0.5px solid #333', backgroundColor: '#1a1a1a', color: '#e8e8e8', fontSize: '12px', fontWeight: '600', cursor: 'pointer', fontFamily: 'Arial, sans-serif' }}>Fechar</button>
        </>;
      } else {
        body = <>
          <div style={{ fontSize: '11px', fontWeight: '700', color: '#7bc47b', letterSpacing: '1px', textTransform: 'uppercase', marginBottom: '10px' }}>Horário livre · {horario}</div>
          {listaBarbeiros.length > 1 ? (
            <>
              <div style={{ fontSize: '10px', color: '#aeaeae', letterSpacing: '1px', textTransform: 'uppercase', marginBottom: '6px' }}>Barbeiro</div>
              <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginBottom: '14px' }}>
                {listaBarbeiros.map(b => (
                  <button key={b} onClick={() => setModalBarb(b)}
                    style={{ padding: '6px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '500', border: `0.5px solid ${barbSelecionado === b ? '#2d4a2d' : '#333'}`, backgroundColor: barbSelecionado === b ? '#2d4a2d' : 'transparent', color: barbSelecionado === b ? '#7bc47b' : '#888', cursor: 'pointer', fontFamily: 'Arial, sans-serif' }}>
                    {b.split(' ')[0]}
                  </button>
                ))}
              </div>
            </>
          ) : (
            <div style={{ fontSize: '12px', color: '#aeaeae', marginBottom: '14px' }}>{barbSelecionado}</div>
          )}
          <div style={{ display: 'flex', gap: '8px' }}>
            <button onClick={() => { fecharModal(); setSlotSelecionado({ barbeiro: barbSelecionado, horario, dia: diaAtivo }); }} style={{ flex: 1, padding: '10px', borderRadius: '9px', border: '0.5px solid #2d4a2d', backgroundColor: '#1a2a1a', color: '#7bc47b', fontSize: '12px', fontWeight: '600', cursor: 'pointer', fontFamily: 'Arial, sans-serif' }}>Agendar</button>
            <button onClick={() => {
              fecharModal();
              setBloqueioHorarios({ fase: 'opcoes', barbeiro: barbSelecionado, horarioInicial: horario, dia: diaAtivo });
            }} style={{ flex: 1, padding: '10px', borderRadius: '9px', border: '0.5px solid #3d1a1a', backgroundColor: '#2a1515', color: '#e05555', fontSize: '12px', fontWeight: '600', cursor: 'pointer', fontFamily: 'Arial, sans-serif' }}>Bloquear</button>
          </div>
        </>;
      }
    }

    if (tipo === 'multi-slot') {
      const { horario, slots } = dados;
      body = <>
        <div style={{ fontSize: '11px', fontWeight: '700', color: '#7bc47b', letterSpacing: '1px', textTransform: 'uppercase', marginBottom: '14px' }}>{horario} · {slots.length} atendimentos</div>
        {slots.map((s, i) => (
          <div key={i} onClick={() => { fecharModal(); setDetalhesSelecionado(s); }} style={{ backgroundColor: '#1a2a1a', border: '0.5px solid #2d4a2d', borderRadius: '8px', padding: '10px 12px', marginBottom: '8px', cursor: 'pointer', ...ST.row }}>
            <div>
              <div style={{ fontSize: '13px', color: '#e8e8e8', fontWeight: '500' }}>{(s.clienteNome || s.cliente || '—')}</div>
              <div style={{ fontSize: '11px', color: '#aeaeae', marginTop: '2px' }}>{s.servico} · {s.barbeiro}</div>
            </div>
            <span style={{ fontSize: '13px', color: '#7bc47b', fontWeight: '600' }}>{s.preco}</span>
          </div>
        ))}
      </>;
    }

    if (tipo === 'conflito-manual') {
      const { barbeiro: barbConflito, horario: horConflito } = dados;
      body = <>
        <div style={{ fontSize: '11px', fontWeight: '700', color: '#e05555', letterSpacing: '1px', textTransform: 'uppercase', marginBottom: '12px' }}>Horário já ocupado</div>
        <p style={{ fontSize: '13px', color: '#ccc', lineHeight: '1.6', marginBottom: '16px' }}>
          <strong style={{ color: '#e8e8e8' }}>{barbConflito?.split(' ')[0]}</strong> já tem uma reserva às{' '}
          <strong style={{ color: '#e8e8e8' }}>{horConflito}</strong>. Escolha outro horário ou barbeiro.
        </p>
        <button onClick={fecharModal} style={{ width: '100%', padding: '10px', borderRadius: '9px', border: '0.5px solid #333', backgroundColor: '#1a1a1a', color: '#e8e8e8', fontSize: '12px', fontWeight: '600', cursor: 'pointer', fontFamily: 'Arial, sans-serif' }}>Entendido</button>
      </>;
    }

    if (tipo === 'excluir-barbeiro') {
      const { nome } = dados;
      body = <>
        <div style={{ fontSize: '11px', fontWeight: '700', color: '#e05555', letterSpacing: '1px', textTransform: 'uppercase', marginBottom: '12px' }}>Atenção</div>
        <p style={{ fontSize: '13px', color: '#e8e8e8', lineHeight: '1.6', marginBottom: '16px' }}>
          <strong>{nome}</strong> pode ter agendamentos futuros confirmados.<br />
          <span style={{ color: '#aeaeae' }}>Não é possível excluí-lo agora. Deseja bloqueá-lo de receber novos agendamentos?</span>
        </p>
        <div style={{ display: 'flex', gap: '8px' }}>
          <button onClick={fecharModal} style={{ flex: 1, padding: '10px', borderRadius: '9px', border: '0.5px solid #333', backgroundColor: 'transparent', color: '#aeaeae', fontSize: '12px', cursor: 'pointer', fontFamily: 'Arial, sans-serif' }}>Cancelar</button>
          <button onClick={fecharModal} style={{ flex: 1, padding: '10px', borderRadius: '9px', border: '0.5px solid #4a3a1a', backgroundColor: '#2a1a0a', color: '#c9a84c', fontSize: '12px', fontWeight: '600', cursor: 'pointer', fontFamily: 'Arial, sans-serif' }}>Bloquear barbeiro</button>
        </div>
      </>;
    }

    if (!body) return null;

    return (
      <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.9)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }} onClick={fecharModal}>
        <div style={{ backgroundColor: '#1a1a1a', borderRadius: '16px', border: '0.5px solid #2d4a2d', padding: '20px', width: '100%', maxWidth: '400px', maxHeight: '80vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
          {body}
          {!['horario-livre', 'excluir-barbeiro', 'multi-slot'].includes(tipo) && (
            <button onClick={fecharModal} style={{ width: '100%', marginTop: '14px', padding: '10px', borderRadius: '9px', border: '0.5px solid #2d4a2d', backgroundColor: '#1a2a1a', color: '#7bc47b', fontSize: '12px', fontWeight: '600', cursor: 'pointer', fontFamily: 'Arial, sans-serif' }}>Fechar</button>
          )}
          {tipo === 'multi-slot' && (
            <button onClick={fecharModal} style={{ width: '100%', marginTop: '6px', padding: '9px', borderRadius: '9px', border: '0.5px solid #333', backgroundColor: 'transparent', color: '#aeaeae', fontSize: '12px', cursor: 'pointer', fontFamily: 'Arial, sans-serif' }}>Fechar</button>
          )}
        </div>
      </div>
    );
  }

  // ── CALENDÁRIO AGENDA ──
  function renderCalendario() {
    const offset = new Date(new Date().getFullYear(), mesIdx, 1).getDay();
    const cells = [];
    for (let i = 0; i < offset; i++) cells.push(<div key={`e${i}`} />);
    diasSemana.forEach((d, i) => {
      const isHoje = d.num === diaHoje && mesAtivo === nomeMesHoje;
      const isAtivo = diaAtivo === d.num;
      const isPassadoDia = mesAtivo === nomeMesHoje && parseInt(d.num) < parseInt(diaHoje);
      cells.push(
        <div key={i} ref={isHoje ? diaRef : null} onClick={() => setDiaAtivo(d.num)}
          style={{ textAlign: 'center', padding: '4px 2px', borderRadius: '8px', cursor: 'pointer', opacity: isPassadoDia ? 0.25 : 1, backgroundColor: isAtivo ? '#2d4a2d' : 'transparent', border: `0.5px solid ${isAtivo ? '#3d6a3d' : isHoje ? '#555' : 'transparent'}` }}>
          <div style={{ fontSize: '9px', color: isAtivo ? '#7bc47b' : '#666', marginBottom: '1px' }}>{d.dia}</div>
          <div style={{ fontSize: '13px', fontWeight: '600', color: isAtivo ? '#e8e8e8' : isHoje ? '#c9a84c' : '#888' }}>{d.num}</div>
        </div>
      );
    });
    return (
      <div style={{ padding: '10px 16px 8px' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
          <span onClick={() => { if (mesIdx > 0) { setMesAtivo(meses[mesIdx - 1]); setDiaAtivo('01'); } }} style={{ fontSize: '22px', color: mesIdx > 0 ? '#7bc47b' : '#333', cursor: 'pointer', padding: '0 6px' }}>‹</span>
          <span style={{ fontSize: '13px', fontWeight: '600', color: '#e8e8e8' }}>{mesAtivo} {new Date().getFullYear()}</span>
          <span onClick={() => { if (mesIdx < meses.length - 1) { setMesAtivo(meses[mesIdx + 1]); setDiaAtivo('01'); } }} style={{ fontSize: '22px', color: mesIdx < meses.length - 1 ? '#7bc47b' : '#333', cursor: 'pointer', padding: '0 6px' }}>›</span>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7,1fr)', gap: '1px', marginBottom: '3px' }}>
          {DIAS_ABV.map(d => <div key={d} style={{ textAlign: 'center', fontSize: '9px', color: '#8f8f8f', padding: '2px 0' }}>{d}</div>)}
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7,1fr)', gap: '2px' }}>{cells}</div>
      </div>
    );
  }

  // ── SLOTS DA AGENDA ──
  function renderAgenda() {
    if (carregandoAgenda) return <p style={{ color: '#8f8f8f', textAlign: 'center', padding: '30px 0', fontSize: '13px' }}>Carregando...</p>;
    if (barbeirosLista.length === 0) return <p style={{ color: '#8f8f8f', textAlign: 'center', padding: '30px 0', fontSize: '13px' }}>Nenhum barbeiro cadastrado.<br />Acesse Config para adicionar.</p>;

    const diaSemana = getDiaSemanaAtivo();
    const amanha = new Date(hoje);
    amanha.setDate(amanha.getDate() + 1);
    const isAmanha = diaAtivo === String(amanha.getDate()).padStart(2, '0') && mesAtivo === meses[amanha.getMonth()];

    // Horas disponíveis para cada barbeiro neste dia
    function horasBarb(nome) {
      const barb = barbeirosObjetos.find(b => b.nome === nome);
      return getHorariosParaBarbeiro(barb, diaSemana);
    }

    // União de horas de todos os barbeiros (view "todos") ou do barbeiro selecionado
    const horariosVisiveis = filtroBarbeiro === 'todos'
      ? HORARIOS.filter(h => barbeirosLista.some(n => horasBarb(n).includes(h)))
      : horasBarb(filtroBarbeiro);

    return (
      <div style={{ padding: '0 14px 16px' }}>
        {/* Pills barbeiros */}
        <div style={{ display: 'flex', gap: '6px', marginBottom: '12px', flexWrap: 'wrap' }}>
          {['todos', ...barbeirosLista].map(b => (
            <button key={b} onClick={() => setFiltroBarbeiro(b)} style={ST.pill(filtroBarbeiro === b)}>
              {b === 'todos' ? 'Todos' : b.split(' ')[0]}
            </button>
          ))}
        </div>

        {horariosVisiveis.length === 0 && (
          <p style={{ color: '#8f8f8f', textAlign: 'center', padding: '24px 0', fontSize: '13px' }}>
            {filtroBarbeiro === 'todos' ? 'Nenhum barbeiro disponível neste dia.' : `${filtroBarbeiro.split(' ')[0]} não trabalha neste dia.`}
          </p>
        )}

        {horariosVisiveis.map(h => {
          const passado = isPassado(h);
          const atual = isAtual(h);

          const TL = atual ? (
            <div ref={timelineRef} style={{ height: '1.5px', backgroundColor: '#fff', margin: '2px 0 4px', position: 'relative', borderRadius: '1px' }}>
              <div style={{ position: 'absolute', left: '-3px', top: '-3px', width: '7px', height: '7px', borderRadius: '50%', backgroundColor: '#fff' }} />
              <span style={{ position: 'absolute', left: '10px', top: '-9px', fontSize: '11px', color: '#fff', fontWeight: '600' }}>
                {String(hoje.getHours()).padStart(2, '0')}:{String(hoje.getMinutes()).padStart(2, '0')}
              </span>
            </div>
          ) : null;

          if (filtroBarbeiro === 'todos') {
            // Barbeiros disponíveis neste horário neste dia
            const barbsNaHora = barbeirosLista.filter(n => horasBarb(n).includes(h));
            const slots = getSlotsHorario(h); // sem filtro por nome — evita perda de agendamentos ao renomear barbeiro

            if (slots.length === 0 && passado) return (
              <div key={h}>{TL}<div style={{ display: 'flex', gap: '8px', padding: '4px 0', borderBottom: '0.5px solid #111', opacity: 0.25 }}>
                <span style={{ fontSize: '11px', color: '#8f8f8f', minWidth: '36px', fontFamily: 'monospace' }}>{h}</span>
              </div></div>
            );

            if (slots.length === 0) {
              // Usar primeiro barbeiro disponível neste horário (não necessariamente lista[0])
              const primeiroDisp = barbsNaHora[0] || barbeirosLista[0];
              return (
                <div key={h}>{TL}
                  <div style={{ display: 'flex', gap: '8px', padding: '5px 0 3px', borderBottom: '0.5px solid #1a1a1a' }}>
                    <span style={{ fontSize: '11px', color: '#a6a6a6', minWidth: '36px', fontFamily: 'monospace', paddingTop: '4px' }}>{h}</span>
                    <div onClick={() => { setModalBarb(primeiroDisp); setModal({ tipo: 'horario-livre', dados: { barbeiro: primeiroDisp, horario: h } }); }} style={{ flex: 1, backgroundColor: '#161616', border: '0.5px dashed #2a2a2a', borderRadius: '6px', padding: '5px 8px', cursor: 'pointer' }}>
                      <span style={{ fontSize: '11px', color: '#9c9c9c' }}>livre — toque para agendar</span>
                    </div>
                  </div>
                </div>
              );
            }

            if (slots.length >= 2) return (
              <div key={h}>{TL}
                <div style={{ padding: '4px 0', borderBottom: '0.5px solid #1a1a1a' }}>
                  <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
                    <span style={{ fontSize: '11px', color: '#7bc47b', minWidth: '36px', fontFamily: 'monospace', opacity: passado ? 0.5 : 1, paddingTop: '5px' }}>{h}</span>
                    <div style={{ flex: 1, display: 'grid', gridTemplateColumns: `repeat(${Math.min(slots.length, 2)}, 1fr)`, gap: '4px' }}>
                      {slots.slice(0, 2).map((s, i) => {
                        const blk = s.status === 'bloqueado';
                        return (
                          <div key={i} onClick={() => passado ? null : setDetalhesSelecionado(s)}
                            style={{ backgroundColor: blk ? '#1a1209' : s.status === 'confirmado' ? '#1a2a1a' : '#2a2010', border: `0.5px solid ${blk ? '#4a3a1a' : s.status === 'confirmado' ? '#2d4a2d' : '#4a3a1a'}`, borderRadius: '6px', padding: '5px 7px', cursor: passado ? 'default' : 'pointer', opacity: passado ? 0.55 : 1 }}>
                            <div style={{ fontSize: '11px', fontWeight: '600', color: blk ? '#c9a84c' : s.status === 'confirmado' ? '#7bc47b' : '#c9a84c', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{blk ? '🔒' : (s.clienteNome || s.cliente || '—')}</div>
                            {!blk && <div style={{ fontSize: '9px', color: '#b6b6b6', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{s.servico}</div>}
                          </div>
                        );
                      })}
                      {slots.length > 2 && (
                        <div onClick={() => setModal({ tipo: 'multi-slot', dados: { horario: h, slots } })} style={{ backgroundColor: '#1a1a1a', border: '0.5px solid #333', borderRadius: '6px', padding: '5px 7px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <span style={{ fontSize: '11px', color: '#aeaeae' }}>+{slots.length - 2}</span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );

            // 1 slot
            const s = slots[0];
            const blk = s.status === 'bloqueado';
            // barbeiros livres neste horário (sem slot algum, nem bloqueado)
            const outrosBarbeiros = barbsNaHora.filter(n =>
              !slots.some(sl => sl.barbeiro === n && sl.status !== 'cancelado')
            );
            // cor do horário: vermelho só se não houver mais nenhum barbeiro livre
            const corHora = outrosBarbeiros.length === 0 ? '#e05555' : '#7bc47b';
            return (
              <div key={h}>{TL}
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center', padding: '4px 0', borderBottom: '0.5px solid #1a1a1a', opacity: passado ? 0.55 : 1 }}>
                  <span style={{ fontSize: '11px', color: corHora, minWidth: '36px', fontFamily: 'monospace' }}>{h}</span>
                  <div onClick={() => !passado && setDetalhesSelecionado(s)} style={{ flex: 1, backgroundColor: blk ? '#1a1209' : s.status === 'confirmado' ? '#1a2a1a' : '#2a2010', border: `0.5px solid ${blk ? '#4a3a1a' : s.status === 'confirmado' ? '#2d4a2d' : '#4a3a1a'}`, borderRadius: '8px', padding: '7px 10px', cursor: passado ? 'default' : 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                      <div style={{ fontSize: '12px', fontWeight: '600', color: blk ? '#c9a84c' : '#e8e8e8' }}>{blk ? `🔒 ${s.barbeiro || 'Bloqueado'}` : (s.clienteNome || s.cliente || '—')}</div>
                      {!blk && <div style={{ fontSize: '10px', color: '#aeaeae', marginTop: '1px' }}>{s.servico} · {s.barbeiro}</div>}
                    </div>
                    {!blk && <span style={ST.tag(s.status === 'confirmado' ? '#1e3320' : '#2a2010', s.status === 'confirmado' ? '#7bc47b' : '#c9a84c', s.status === 'confirmado' ? '#2d4a2d' : '#4a3a1a')}>{s.status === 'confirmado' ? 'conf.' : 'pend.'}</span>}
                  </div>
                  {isAmanha && !blk && (s.clienteTelefone || s.telefone) && (
                    <div onClick={e => { e.stopPropagation(); abrirLembrete(s); }}
                      style={{ width: '28px', height: '28px', borderRadius: '50%', border: '0.5px solid #25a244', backgroundColor: '#0f1f0f', color: '#25d366', cursor: 'pointer', fontSize: '13px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}
                      title="Lembrar no WhatsApp">💬</div>
                  )}
                  {!passado && outrosBarbeiros.length > 0 && (
                    <div onClick={() => { const b = outrosBarbeiros[0]; setModalBarb(b); setModal({ tipo: 'horario-livre', dados: { barbeiro: b, horario: h } }); }}
                      style={{ width: '28px', height: '28px', borderRadius: '50%', border: '0.5px dashed #555', backgroundColor: 'transparent', color: '#a6a6a6', cursor: 'pointer', fontSize: '18px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>+</div>
                  )}
                </div>
              </div>
            );
          } else {
            // Barbeiro individual
            const barbeiro = filtroBarbeiro;
            const s = getSlot(barbeiro, h);
            const blk = s?.status === 'bloqueado';
            return (
              <div key={h}>{TL}
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center', padding: '4px 0', borderBottom: '0.5px solid #1a1a1a', opacity: passado && !s ? 0.3 : passado && s ? 0.55 : 1 }}>
                  <span style={{ fontSize: '11px', color: blk ? '#e05555' : s ? '#7bc47b' : '#777', minWidth: '36px', fontFamily: 'monospace' }}>{h}</span>
                  {s ? (
                    <>
                      <div onClick={() => !passado && setDetalhesSelecionado(s)} style={{ flex: 1, backgroundColor: blk ? '#1a1209' : s.status === 'confirmado' ? '#1a2a1a' : '#2a2010', border: `0.5px solid ${blk ? '#4a3a1a' : s.status === 'confirmado' ? '#2d4a2d' : '#4a3a1a'}`, borderRadius: '8px', padding: '7px 10px', cursor: passado ? 'default' : 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div>
                          <div style={{ fontSize: '12px', fontWeight: '600', color: blk ? '#c9a84c' : '#e8e8e8' }}>{blk ? 'Bloqueado' : (s.clienteNome || s.cliente || '—')}</div>
                          {!blk && <div style={{ fontSize: '10px', color: '#aeaeae', marginTop: '1px' }}>{s.servico} · {fmtR(parsePreco(s.preco))}</div>}
                        </div>
                        {!blk && <span style={ST.tag(s.status === 'confirmado' ? '#1e3320' : '#2a2010', s.status === 'confirmado' ? '#7bc47b' : '#c9a84c', s.status === 'confirmado' ? '#2d4a2d' : '#4a3a1a')}>{s.status === 'confirmado' ? 'conf.' : 'pend.'}</span>}
                      </div>
                      {isAmanha && !blk && (s.clienteTelefone || s.telefone) && (
                        <div onClick={e => { e.stopPropagation(); abrirLembrete(s); }}
                          style={{ width: '28px', height: '28px', borderRadius: '50%', border: '0.5px solid #25a244', backgroundColor: '#0f1f0f', color: '#25d366', cursor: 'pointer', fontSize: '13px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}
                          title="Lembrar no WhatsApp">💬</div>
                      )}
                    </>
                  ) : !passado ? (
                    <div onClick={() => abrirHorario(barbeiro, h)} style={{ flex: 1, backgroundColor: '#161616', border: '0.5px dashed #222', borderRadius: '7px', padding: '7px 10px', cursor: 'pointer' }}>
                      <span style={{ fontSize: '11px', color: '#9c9c9c' }}>livre — toque para agendar ou bloquear</span>
                    </div>
                  ) : <div style={{ flex: 1, height: '18px' }} />}
                </div>
              </div>
            );
          }
        })}
      </div>
    );
  }

  // ── CALENDÁRIO EXTRATO MENSAL ──
  function renderCalExtrato() {
    const ano = extratoMes.getFullYear();
    const mesE = extratoMes.getMonth();
    const offset = new Date(ano, mesE, 1).getDay();
    const total = new Date(ano, mesE + 1, 0).getDate();
    const cells = [];
    for (let i = 0; i < offset; i++) cells.push(<div key={`e${i}`} />);
    for (let d = 1; d <= total; d++) {
      const k = String(d).padStart(2, '0');
      const val = calData[k];
      const isToday = d === hoje.getDate() && mesE === hoje.getMonth() && ano === hoje.getFullYear();
      cells.push(
        <div key={d} onClick={() => val && (setExtTab('diario'), setExtratoData(new Date(ano, mesE, d)))}
          style={{ textAlign: 'center', padding: '3px 1px', borderRadius: '6px', cursor: val ? 'pointer' : 'default', backgroundColor: isToday ? '#2d4a2d' : val ? '#1a1a1a' : 'transparent', border: `0.5px solid ${isToday ? '#3d6a3d' : val ? '#242424' : 'transparent'}` }}>
          <div style={{ fontSize: '11px', fontWeight: '500', color: isToday ? '#7bc47b' : val ? '#e8e8e8' : '#444' }}>{d}</div>
          {val && <div style={{ fontSize: '7px', color: '#7bc47b', marginTop: '1px' }}>{fmtR(val).replace('R$ ', '')}</div>}
        </div>
      );
    }
    return <>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7,1fr)', gap: '1px', marginBottom: '3px' }}>
        {DIAS_ABV.map(d => <div key={d} style={{ textAlign: 'center', fontSize: '8px', color: '#8f8f8f', padding: '2px 0' }}>{d}</div>)}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7,1fr)', gap: '2px' }}>{cells}</div>
    </>;
  }

  // ── BOTTOM BAR ──
  function BarBtn({ id, label, children }) {
    const on = aba === id;
    return (
      <button onClick={() => setAba(id)} style={ST.bbBtn(on)}>
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" stroke={on ? '#7bc47b' : '#555'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">{children}</svg>
        <span style={{ fontSize: '9px', fontWeight: '500', fontFamily: 'Arial, sans-serif', color: on ? '#7bc47b' : '#555' }}>{label}</span>
      </button>
    );
  }

  // ══════════════════════════════════════════════
  //                 RENDER PRINCIPAL
  // ══════════════════════════════════════════════

  // Tela de perfil sobreposta (para cadastro pendente)
  if (mostrarPerfil) {
    return (
      <div style={{ backgroundColor: '#111111', minHeight: '100vh', fontFamily: 'Arial, sans-serif', color: '#e8e8e8' }}>
        <div style={{ padding: '16px 20px', borderBottom: '1px solid #1a1a1a', display: 'flex', alignItems: 'center', gap: '12px' }}>
          <span onClick={() => setMostrarPerfil(false)} style={{ fontSize: '22px', color: '#b6b6b6', cursor: 'pointer' }}>‹</span>
          <span style={{ fontSize: '15px', fontWeight: '600' }}>Dados da barbearia</span>
        </div>
        <PerfilBarbearia
          barbearia={barbearia}
          onAtualizar={dados => {
            setBarbearia(prev => ({ ...prev, ...dados }));
            setMostrarPerfil(false);
          }}
        />
      </div>
    );
  }

  // Status gate — barbearia pendente: sempre mostra "aguardando análise"
  // Com o novo fluxo de cadastro (CadastroBarbearia), todos os dados já foram preenchidos
  if (barbearia && barbearia.status === 'pendente') {
    return (
      <div style={{
        backgroundColor: '#111111', minHeight: '100vh',
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        fontFamily: 'Arial, sans-serif', padding: '32px 24px', textAlign: 'center'
      }}>
        <img src={logo} alt="BLADE" style={{ width: '120px', marginBottom: '32px' }} />

        <div style={{ fontSize: '40px', marginBottom: '16px' }}>⏳</div>
        <h2 style={{ fontSize: '20px', fontWeight: '700', color: '#e8e8e8', marginBottom: '8px' }}>
          Cadastro em análise
        </h2>
        <p style={{ fontSize: '13px', color: '#8f8f8f', lineHeight: '1.8', marginBottom: '28px' }}>
          Recebemos seu cadastro e estamos analisando.<br />
          A análise é feita em até <span style={{ color: '#c9a84c' }}>24 horas</span>.<br />
          Dúvidas? <span style={{ color: '#7bc47b' }}>blade.app.conta@gmail.com</span>
        </p>

        <button
          onClick={onVoltar}
          style={{
            backgroundColor: 'transparent', color: '#7d7d7d',
            border: '0.5px solid #2a2a2a', borderRadius: '12px',
            padding: '12px 24px', fontSize: '13px', cursor: 'pointer',
            fontFamily: 'Arial, sans-serif', width: '100%', maxWidth: '280px'
          }}>
          Voltar ao início
        </button>
      </div>
    );
  }

  if (barbearia && barbearia.status === 'rejeitado') {
    return (
      <div style={{
        backgroundColor: '#111111', minHeight: '100vh',
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        fontFamily: 'Arial, sans-serif', padding: '24px', textAlign: 'center'
      }}>
        <img src={logo} alt="BLADE" style={{ width: '120px', marginBottom: '32px' }} />
        <div style={{ fontSize: '40px', marginBottom: '16px' }}>❌</div>
        <h2 style={{ fontSize: '20px', fontWeight: '700', color: '#e24b4a', marginBottom: '8px' }}>
          Cadastro não aprovado
        </h2>
        <p style={{ fontSize: '13px', color: '#8f8f8f', lineHeight: '1.7' }}>
          Seu cadastro não foi aprovado.<br />
          Entre em contato: blade.app.conta@gmail.com
        </p>
      </div>
    );
  }

  return (
    <div style={{ backgroundColor: '#0a0a0a', minHeight: '100vh', fontFamily: 'Arial, sans-serif', color: '#e8e8e8', paddingBottom: '70px' }}>
      <style>{`@keyframes pulse{0%,100%{transform:scale(1);opacity:.4}50%{transform:scale(1.6);opacity:.1}} ::-webkit-scrollbar{width:0;height:0}`}</style>

      {/* ── Modais ── */}
      {slotSelecionado && (
        <AgendamentoManual
          horario={slotSelecionado.horario}
          barbeiro={slotSelecionado.barbeiro}
          dia={slotSelecionado.dia}
          mes={mesAtivo}
          diasSemana={diasSemana}
          meses={meses}
          getDiasSemana={getDiasSemana}
          barbeirosLista={barbeirosLista}
          servicosLista={servicosLista}
          tipoInicial={slotSelecionado.tipoInicial}
          periodoBlockInicial={slotSelecionado.periodoBlockInicial}
          todosAgends={todosAgends}
          onSalvar={salvarAgendamento}
          onSalvarMultiplos={salvarMultiplos}
          onFechar={() => setSlotSelecionado(null)}
        />
      )}
      {/* Modal: bloquear com reservas existentes */}
      {confirmBloqueio && (
        <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.9)', zIndex: 300, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
          <div style={{ backgroundColor: '#1a1a1a', borderRadius: '16px', border: '0.5px solid #4a1a1a', padding: '20px', width: '100%', maxWidth: '400px' }}>
            {faseBloqueio === 1 ? (<>
              <div style={{ fontSize: '11px', fontWeight: '700', color: '#e05555', letterSpacing: '1px', textTransform: 'uppercase', marginBottom: '10px' }}>⚠️ Há {confirmBloqueio.conflitos.length} reserva{confirmBloqueio.conflitos.length > 1 ? 's' : ''} neste período</div>
              <p style={{ fontSize: '13px', color: '#ccc', lineHeight: '1.6', marginBottom: '16px' }}>
                Deseja <strong style={{ color: '#e05555' }}>cancelar as {confirmBloqueio.conflitos.length} reserva{confirmBloqueio.conflitos.length > 1 ? 's' : ''}</strong> e bloquear, ou bloquear apenas os horários livres?
              </p>
              <button onClick={() => setFaseBloqueio(2)} style={{ width: '100%', marginBottom: '8px', padding: '11px', borderRadius: '9px', border: '0.5px solid #4a1a1a', backgroundColor: '#2a1515', color: '#e05555', fontSize: '12px', fontWeight: '600', cursor: 'pointer', fontFamily: 'Arial, sans-serif' }}>
                Cancelar as {confirmBloqueio.conflitos.length} reserva{confirmBloqueio.conflitos.length > 1 ? 's' : ''} e bloquear
              </button>
              <button onClick={() => { setConfirmBloqueio(null); setFaseBloqueio(1); setSlotSelecionado({ barbeiro: confirmBloqueio.barbeiro, horario: confirmBloqueio.horario, dia: confirmBloqueio.dia, tipoInicial: 'bloqueado' }); }} style={{ width: '100%', marginBottom: '8px', padding: '11px', borderRadius: '9px', border: '0.5px solid #333', backgroundColor: '#1a2a1a', color: '#7bc47b', fontSize: '12px', fontWeight: '600', cursor: 'pointer', fontFamily: 'Arial, sans-serif' }}>
                Bloquear apenas horários livres
              </button>
              <button onClick={() => { setConfirmBloqueio(null); setFaseBloqueio(1); }} style={{ width: '100%', padding: '9px', borderRadius: '9px', border: '0.5px solid #252525', backgroundColor: 'transparent', color: '#8f8f8f', fontSize: '12px', cursor: 'pointer', fontFamily: 'Arial, sans-serif' }}>Cancelar</button>
            </>) : (<>
              <div style={{ fontSize: '11px', fontWeight: '700', color: '#e05555', letterSpacing: '1px', textTransform: 'uppercase', marginBottom: '10px' }}>Confirmar cancelamento</div>
              <p style={{ fontSize: '13px', color: '#ccc', lineHeight: '1.6', marginBottom: '16px' }}>
                Os clientes serão <strong style={{ color: '#c9a84c' }}>notificados via WhatsApp</strong> sobre o cancelamento. Deseja continuar?
              </p>
              <button onClick={() => { setConfirmBloqueio(null); setFaseBloqueio(1); setSlotSelecionado({ barbeiro: confirmBloqueio.barbeiro, horario: confirmBloqueio.horario, dia: confirmBloqueio.dia, tipoInicial: 'bloqueado' }); }}
                style={{ width: '100%', marginBottom: '8px', padding: '11px', borderRadius: '9px', border: '0.5px solid #4a1a1a', backgroundColor: '#2a1515', color: '#e05555', fontSize: '12px', fontWeight: '600', cursor: 'pointer', fontFamily: 'Arial, sans-serif' }}>
                Sim, cancelar e bloquear
              </button>
              <button onClick={() => setFaseBloqueio(1)} style={{ width: '100%', padding: '9px', borderRadius: '9px', border: '0.5px solid #252525', backgroundColor: 'transparent', color: '#8f8f8f', fontSize: '12px', cursor: 'pointer', fontFamily: 'Arial, sans-serif' }}>Voltar</button>
            </>)}
          </div>
        </div>
      )}

      {/* Modal: novo fluxo de bloqueio de horários do dia */}
      {bloqueioHorarios && (() => {
        const { fase, barbeiro, horarioInicial, dia, horariosBarb = [], selecionados = new Set(), conflitos = [], selecionadosFinal = [] } = bloqueioHorarios;

        if (fase === 'opcoes') return (
          <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.9)', zIndex: 300, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }} onClick={() => setBloqueioHorarios(null)}>
            <div style={{ backgroundColor: '#1a1a1a', borderRadius: '16px', border: '0.5px solid #333', padding: '20px', width: '100%', maxWidth: '400px' }} onClick={e => e.stopPropagation()}>
              <div style={{ fontSize: '11px', fontWeight: '700', color: '#c9a84c', letterSpacing: '1px', textTransform: 'uppercase', marginBottom: '4px' }}>Bloquear · {horarioInicial}</div>
              <div style={{ fontSize: '12px', color: '#aeaeae', marginBottom: '18px' }}>{barbeiro}</div>
              <button onClick={() => {
                const barb = barbeirosObjetos.find(b => b.nome === barbeiro);
                const ds = getDiaSemanaAtivo();
                const hrs = getHorariosParaBarbeiro(barb, ds);
                setBloqueioHorarios({ fase: 'grid', barbeiro, horarioInicial, dia, horariosBarb: hrs, selecionados: new Set([horarioInicial]) });
              }} style={{ width: '100%', marginBottom: '8px', padding: '12px 14px', borderRadius: '10px', border: '0.5px solid #4a3a1a', backgroundColor: '#2a200a', color: '#c9a84c', fontSize: '13px', fontWeight: '600', cursor: 'pointer', textAlign: 'left', fontFamily: 'Arial, sans-serif' }}>
                <div>🕐 Bloquear horários</div>
                <div style={{ fontSize: '11px', color: '#9c9c9c', fontWeight: '400', marginTop: '2px' }}>Selecione múltiplos horários do dia</div>
              </button>
              <button onClick={() => {
                setBloqueioHorarios(null);
                setSlotSelecionado({ barbeiro, horario: horarioInicial, dia, tipoInicial: 'bloqueado', periodoBlockInicial: 'periodo' });
              }} style={{ width: '100%', marginBottom: '12px', padding: '12px 14px', borderRadius: '10px', border: '0.5px solid #3d1a1a', backgroundColor: '#2a1515', color: '#e05555', fontSize: '13px', fontWeight: '600', cursor: 'pointer', textAlign: 'left', fontFamily: 'Arial, sans-serif' }}>
                <div>📅 Bloquear período de datas</div>
                <div style={{ fontSize: '11px', color: '#9c9c9c', fontWeight: '400', marginTop: '2px' }}>Bloqueia todos os horários de um intervalo de dias</div>
              </button>
              <button onClick={() => setBloqueioHorarios(null)} style={{ width: '100%', padding: '9px', borderRadius: '9px', border: '0.5px solid #252525', backgroundColor: 'transparent', color: '#8f8f8f', fontSize: '12px', cursor: 'pointer', fontFamily: 'Arial, sans-serif' }}>Cancelar</button>
            </div>
          </div>
        );

        if (fase === 'grid') {
          const agendsDia = todosAgends.filter(a =>
            a.barbeiro === barbeiro &&
            a.dia === dia &&
            (a.mes === mesAtivo || !a.mes) &&
            a.status !== 'cancelado'
          );
          return (
            <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.9)', zIndex: 300, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
              <div style={{ backgroundColor: '#1a1a1a', borderRadius: '16px', border: '0.5px solid #333', padding: '20px', width: '100%', maxWidth: '400px', maxHeight: '85vh', overflowY: 'auto' }}>
                <div style={{ fontSize: '11px', fontWeight: '700', color: '#c9a84c', letterSpacing: '1px', textTransform: 'uppercase', marginBottom: '4px' }}>Selecionar horários</div>
                <div style={{ fontSize: '12px', color: '#aeaeae', marginBottom: '16px' }}>{barbeiro} · {parseInt(dia)}/{meses.indexOf(mesAtivo) + 1}</div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '6px', marginBottom: '14px' }}>
                  {horariosBarb.map(h => {
                    const passado = isPassado(h);
                    const slotExist = agendsDia.find(a => a.horario === h);
                    const jaBloqueado = slotExist?.status === 'bloqueado';
                    const temReserva = slotExist && !jaBloqueado;
                    const sel = selecionados.has(h);
                    let bg, border, color, opacity = 1, cursor = 'pointer';
                    if (passado) { bg = 'transparent'; border = '#222'; color = '#555'; opacity = 0.5; cursor = 'not-allowed'; }
                    else if (jaBloqueado) { bg = '#1a0808'; border = '#5a1a1a'; color = '#e05555'; cursor = 'default'; }
                    else if (temReserva && sel) { bg = '#1e2a10'; border = '#7bc47b'; color = '#7bc47b'; }
                    else if (temReserva) { bg = '#2a1a0a'; border = '#c9a84c'; color = '#c9a84c'; }
                    else if (sel) { bg = '#1a2a1a'; border = '#7bc47b'; color = '#7bc47b'; }
                    else { bg = '#111'; border = '#252525'; color = '#888'; }
                    const icone = jaBloqueado ? ' 🔒' : temReserva ? ' ⚠️' : sel ? ' ✓' : '';
                    return (
                      <div key={h} onClick={() => {
                        if (passado || jaBloqueado) return;
                        const next = new Set(selecionados);
                        if (next.has(h)) next.delete(h); else next.add(h);
                        setBloqueioHorarios(prev => ({ ...prev, selecionados: next }));
                      }} style={{ backgroundColor: bg, border: `0.5px solid ${border}`, borderRadius: '8px', padding: '8px 4px', textAlign: 'center', cursor, opacity }}>
                        <div style={{ fontSize: '12px', fontWeight: '600', color, fontFamily: 'monospace', whiteSpace: 'nowrap' }}>{h}{icone}</div>
                      </div>
                    );
                  })}
                </div>
                {horariosBarb.some(h => { const s = agendsDia.find(a => a.horario === h); return s && s.status !== 'bloqueado'; }) && (
                  <div style={{ fontSize: '10px', color: '#8f8f8f', marginBottom: '12px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                    <span>⚠️ tem reserva</span><span>🔒 já bloqueado</span><span>✓ selecionado</span>
                  </div>
                )}
                <button onClick={() => {
                  const lista = [...selecionados];
                  if (!lista.length) return;
                  const conflitosH = agendsDia.filter(a => lista.includes(a.horario) && a.status !== 'bloqueado');
                  if (conflitosH.length > 0) {
                    setBloqueioHorarios(prev => ({ ...prev, fase: 'conflitos', conflitos: conflitosH, selecionadosFinal: lista }));
                  } else {
                    salvarBloqueiosHorarios(barbeiro, dia, lista, []);
                  }
                }} disabled={selecionados.size === 0} style={{ width: '100%', marginBottom: '8px', padding: '11px', borderRadius: '9px', border: `0.5px solid ${selecionados.size > 0 ? '#4a3a1a' : '#1a1a1a'}`, backgroundColor: selecionados.size > 0 ? '#2a1a0a' : '#111', color: selecionados.size > 0 ? '#c9a84c' : '#333', fontSize: '12px', fontWeight: '600', cursor: selecionados.size > 0 ? 'pointer' : 'not-allowed', fontFamily: 'Arial, sans-serif' }}>
                  Confirmar bloqueio{selecionados.size > 0 ? ` (${selecionados.size})` : ''}
                </button>
                <button onClick={() => setBloqueioHorarios(null)} style={{ width: '100%', padding: '9px', borderRadius: '9px', border: '0.5px solid #252525', backgroundColor: 'transparent', color: '#8f8f8f', fontSize: '12px', cursor: 'pointer', fontFamily: 'Arial, sans-serif' }}>Cancelar</button>
              </div>
            </div>
          );
        }

        if (fase === 'conflitos') return (
          <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.9)', zIndex: 300, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
            <div style={{ backgroundColor: '#1a1a1a', borderRadius: '16px', border: '0.5px solid #4a1a1a', padding: '20px', width: '100%', maxWidth: '400px', maxHeight: '85vh', overflowY: 'auto' }}>
              <div style={{ fontSize: '11px', fontWeight: '700', color: '#e05555', letterSpacing: '1px', textTransform: 'uppercase', marginBottom: '12px' }}>
                ⚠️ {conflitos.length} horário{conflitos.length > 1 ? 's' : ''} com reserva{conflitos.length > 1 ? 's' : ''}
              </div>
              {conflitos.map((c, i) => (
                <div key={i} style={{ backgroundColor: '#1a1209', border: '0.5px solid #4a3a1a', borderRadius: '8px', padding: '10px 12px', marginBottom: '8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div style={{ fontSize: '12px', color: '#e8e8e8', fontWeight: '500' }}>{c.horario} · {c.clienteNome || c.cliente || '—'}</div>
                    <div style={{ fontSize: '10px', color: '#aeaeae', marginTop: '1px' }}>{c.servico}</div>
                  </div>
                  {(c.clienteTelefone || c.telefone) && (
                    <div onClick={() => {
                      const tel = (c.clienteTelefone || c.telefone || '').replace(/\D/g, '');
                      const msg = encodeURIComponent(`Olá ${c.clienteNome || ''}! Infelizmente precisamos cancelar seu agendamento das ${c.horario}. Pedimos desculpas pelo inconveniente.`);
                      window.open(`https://wa.me/${tel}?text=${msg}`, '_blank');
                    }} style={{ width: '30px', height: '30px', borderRadius: '50%', border: '0.5px solid #25a244', backgroundColor: '#0f1f0f', color: '#25d366', cursor: 'pointer', fontSize: '14px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }} title="Avisar no WhatsApp">💬</div>
                  )}
                </div>
              ))}
              <p style={{ fontSize: '12px', color: '#aeaeae', lineHeight: '1.5', marginBottom: '14px', marginTop: '4px' }}>
                Deseja <strong style={{ color: '#e05555' }}>cancelar as reservas e bloquear</strong> todos os horários selecionados, ou bloquear apenas os horários livres?
              </p>
              <button onClick={() => salvarBloqueiosHorarios(barbeiro, dia, selecionadosFinal, conflitos)} style={{ width: '100%', marginBottom: '8px', padding: '11px', borderRadius: '9px', border: '0.5px solid #4a1a1a', backgroundColor: '#2a1515', color: '#e05555', fontSize: '12px', fontWeight: '600', cursor: 'pointer', fontFamily: 'Arial, sans-serif' }}>
                Cancelar reservas e bloquear todos
              </button>
              <button onClick={() => {
                const livres = selecionadosFinal.filter(h => !conflitos.some(c => c.horario === h));
                salvarBloqueiosHorarios(barbeiro, dia, livres, []);
              }} style={{ width: '100%', marginBottom: '8px', padding: '11px', borderRadius: '9px', border: '0.5px solid #2d4a2d', backgroundColor: '#1a2a1a', color: '#7bc47b', fontSize: '12px', fontWeight: '600', cursor: 'pointer', fontFamily: 'Arial, sans-serif' }}>
                Bloquear apenas horários livres
              </button>
              <button onClick={() => setBloqueioHorarios(prev => ({ ...prev, fase: 'grid' }))} style={{ width: '100%', padding: '9px', borderRadius: '9px', border: '0.5px solid #252525', backgroundColor: 'transparent', color: '#8f8f8f', fontSize: '12px', cursor: 'pointer', fontFamily: 'Arial, sans-serif' }}>Voltar</button>
            </div>
          </div>
        );

        return null;
      })()}

      {detalhesSelecionado && (
        <DetalhesAgendamento
          agendamento={detalhesSelecionado}
          onFechar={() => setDetalhesSelecionado(null)}
          onCancelado={() => setDetalhesSelecionado(null)}
        />
      )}

      {/* Toast: novo agendamento recebido pelo app */}
      {novoAgendToast && (() => {
        // Resolve a versão com PII mesclada (o doc de contato chega por listener próprio)
        const toast = todosAgends.find(a => a.id === novoAgendToast.id) || novoAgendToast;
        return (
        <div
          onClick={() => { setAba('agenda'); if (toast.mes) setMesAtivo(toast.mes); if (toast.dia) setDiaAtivo(toast.dia); setDetalhesSelecionado(toast); setNovoAgendToast(null); }}
          style={{
            position: 'fixed', top: '16px', left: '50%', transform: 'translateX(-50%)',
            zIndex: 500, width: 'calc(100% - 32px)', maxWidth: '440px',
            backgroundColor: '#1a2a1a', border: '1px solid #2d4a2d',
            borderRadius: '14px', padding: '14px 16px',
            display: 'flex', alignItems: 'center', gap: '12px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.6)', cursor: 'pointer'
          }}>
          <span style={{ fontSize: '22px' }}>📅</span>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: '12px', fontWeight: '700', color: '#7bc47b', marginBottom: '2px' }}>
              {toast.status === 'pendente' ? 'Nova solicitação! ⏳' : 'Novo agendamento!'}
            </div>
            <div style={{ fontSize: '12px', color: '#ccc' }}>
              {toast.clienteNome || 'Cliente'} — {toast.horario} · {toast.servico}
            </div>
            <div style={{ fontSize: '10px', color: '#8f8f8f', marginTop: '2px' }}>toque para ver detalhes</div>
          </div>
          <span onClick={e => { e.stopPropagation(); setNovoAgendToast(null); }} style={{ color: '#8f8f8f', cursor: 'pointer', fontSize: '18px' }}>×</span>
        </div>
        );
      })()}
      {renderModal()}

      {/* ── Header ── */}
      <div style={{ padding: '14px 18px 12px', borderBottom: '1px solid #1a1a1a', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{ width: '40px', height: '40px', borderRadius: '50%', border: '2px solid #2d4a2d', overflow: 'hidden', backgroundColor: '#1a2a1a', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            {barbearia?.foto ? <img src={barbearia.foto} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <span style={{ fontSize: '18px' }}>✂️</span>}
          </div>
          <div>
            <div style={{ fontSize: '14px', fontWeight: '700', color: '#e8e8e8' }}>{nomeBarbearia || 'Minha Barbearia'}</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginTop: '2px' }}>
              <div style={{ position: 'relative', width: '7px', height: '7px' }}>
                <div style={{ width: '7px', height: '7px', borderRadius: '50%', backgroundColor: '#7bc47b' }} />
                <div style={{ position: 'absolute', top: '-3px', left: '-3px', width: '13px', height: '13px', borderRadius: '50%', backgroundColor: '#7bc47b', opacity: 0.3, animation: 'pulse 2s infinite' }} />
              </div>
              <span style={{ fontSize: '10px', color: '#7bc47b' }}>Online</span>
            </div>
          </div>
        </div>
        <img src={logo} alt="BLADE" style={{ height: '24px', opacity: 0.6, cursor: 'pointer' }} onClick={onVoltar} />
      </div>

      {/* ══ HOME ══ */}
      {aba === 'home' && (
        <div style={{ padding: '14px 16px', paddingBottom: '148px' }}>
          <div style={ST.stb}>
            <button style={ST.stbBtn(homeTab === 'resumo')} onClick={() => setHomeTab('resumo')}>Resumo</button>
            <button style={ST.stbBtn(homeTab === 'ofertas')} onClick={() => setHomeTab('ofertas')}>Ofertas</button>
          </div>

          {homeTab === 'resumo' && (
            <>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '9px', marginBottom: '10px' }}>
                <div style={{ ...ST.card, marginBottom: 0 }}>
                  <div style={{ fontSize: '10px', color: '#aeaeae', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '4px' }}>Hoje</div>
                  <div style={{ fontSize: '24px', fontWeight: '700', color: '#e8e8e8' }}>{agendamentosHoje.filter(a => a.status !== 'bloqueado').length}</div>
                  <div style={{ fontSize: '10px', color: '#7bc47b' }}>agendamentos</div>
                </div>
                <div style={{ ...ST.card, marginBottom: 0 }}>
                  <div style={{ fontSize: '10px', color: '#aeaeae', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '4px' }}>Faturamento</div>
                  <div style={{ fontSize: '18px', fontWeight: '700', color: '#e8e8e8' }}>{fmtR(finHoje.bruto)}</div>
                  <div style={{ fontSize: '10px', color: '#7bc47b' }}>esperado hoje</div>
                </div>
              </div>

              {proximoCliente && (
                <div style={ST.greenCard}>
                  <div style={{ fontSize: '9px', color: '#7bc47b', fontWeight: '700', letterSpacing: '1px', textTransform: 'uppercase', marginBottom: '5px' }}>Próximo cliente</div>
                  <div style={{ fontSize: '17px', fontWeight: '700', color: '#e8e8e8', marginBottom: '2px' }}>{proximoCliente.clienteNome || proximoCliente.cliente || '—'}</div>
                  <div style={{ fontSize: '12px', color: '#7bc47b' }}>{proximoCliente.horario} · {proximoCliente.servico} · {proximoCliente.barbeiro}</div>
                </div>
              )}

              <div style={ST.card}>
                <div style={{ fontSize: '10px', color: '#aeaeae', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '10px' }}>Atividades</div>

                {/* Seletor de abas */}
                <div style={{ display: 'flex', gap: '3px', backgroundColor: '#111', borderRadius: '8px', padding: '3px', marginBottom: '12px' }}>
                  {[['proximos', 'Próximos'], ['pendentes', 'Pendentes'], ['agendamentos', 'Agendamentos'], ['cancelamentos', 'Cancelamentos']].map(([id, lbl]) => (
                    <button key={id} onClick={() => setActivityTab(id)} style={{ flex: 1, padding: '5px 2px', borderRadius: '6px', border: 'none', fontSize: '9px', fontWeight: '600', cursor: 'pointer', fontFamily: 'Arial, sans-serif', textTransform: 'uppercase', letterSpacing: '0.4px', backgroundColor: activityTab === id ? '#1a2a1a' : 'transparent', color: activityTab === id ? '#7bc47b' : '#555', position: 'relative' }}>
                      {lbl}
                      {id === 'pendentes' && atividadePendentes.length > 0 && (
                        <span style={{ marginLeft: '3px', fontSize: '8px', color: '#c9a84c', fontWeight: '700' }}>({atividadePendentes.length})</span>
                      )}
                    </button>
                  ))}
                </div>

                {/* Aba: Próximos atendimentos */}
                {activityTab === 'proximos' && (
                  atividadeProximos.length === 0
                    ? <p style={{ fontSize: '12px', color: '#8f8f8f', textAlign: 'center', padding: '12px 0', margin: 0 }}>Nenhum atendimento agendado.</p>
                    : atividadeProximos.map((a, i) => (
                        <div key={a.id || i} onClick={() => setDetalhesSelecionado(a)} style={{ display: 'flex', gap: '10px', padding: '8px 0', borderBottom: i < atividadeProximos.length - 1 ? '0.5px solid #1e1e1e' : 'none', cursor: 'pointer', alignItems: 'flex-start' }}>
                          <div style={{ width: '7px', height: '7px', borderRadius: '50%', backgroundColor: a.status === 'confirmado' ? '#7bc47b' : '#c9a84c', marginTop: '4px', flexShrink: 0 }} />
                          <div style={{ flex: 1 }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2px' }}>
                              <span style={{ fontSize: '12px', color: '#e8e8e8', fontWeight: '500' }}>{a.clienteNome || a.cliente || '—'}</span>
                              <span style={{ fontSize: '10px', color: a.status === 'confirmado' ? '#7bc47b' : '#c9a84c' }}>{a.status === 'confirmado' ? 'conf.' : 'pend.'}</span>
                            </div>
                            <div style={{ fontSize: '11px', color: '#c9a84c', fontWeight: '600', marginBottom: '1px' }}>{fmtApptDia(a)} · {a.horario}</div>
                            <div style={{ fontSize: '10px', color: '#8f8f8f' }}>{a.servico} · {a.barbeiro}</div>
                          </div>
                        </div>
                      ))
                )}

                {/* Aba: Pendentes (aguardando aprovação) */}
                {activityTab === 'pendentes' && (
                  atividadePendentes.length === 0
                    ? <p style={{ fontSize: '12px', color: '#8f8f8f', textAlign: 'center', padding: '12px 0', margin: 0 }}>Nenhum agendamento aguardando aprovação.</p>
                    : atividadePendentes.map((a, i) => (
                        <div key={a.id || i} onClick={() => setDetalhesSelecionado(a)} style={{ display: 'flex', gap: '10px', padding: '8px 0', borderBottom: i < atividadePendentes.length - 1 ? '0.5px solid #1e1e1e' : 'none', cursor: 'pointer', alignItems: 'flex-start' }}>
                          <div style={{ width: '7px', height: '7px', borderRadius: '50%', backgroundColor: '#c9a84c', marginTop: '4px', flexShrink: 0 }} />
                          <div style={{ flex: 1 }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2px' }}>
                              <span style={{ fontSize: '12px', color: '#e8e8e8', fontWeight: '500' }}>{a.clienteNome || a.cliente || '—'}</span>
                              <span style={{ fontSize: '10px', color: '#c9a84c' }}>pend.</span>
                            </div>
                            <div style={{ fontSize: '11px', color: '#c9a84c', fontWeight: '600', marginBottom: '1px' }}>{fmtApptDia(a)} · {a.horario}</div>
                            <div style={{ fontSize: '10px', color: '#8f8f8f', marginBottom: '6px' }}>{a.servico} · {a.barbeiro}</div>
                            <button onClick={(e) => confirmarPendente(e, a)} style={{ fontSize: '10px', fontWeight: '600', color: '#7bc47b', backgroundColor: '#1a2a1a', border: '0.5px solid #2d4a2d', borderRadius: '14px', padding: '4px 12px', cursor: 'pointer', fontFamily: 'Arial, sans-serif' }}>✓ Confirmar</button>
                          </div>
                        </div>
                      ))
                )}

                {/* Aba: Agendamentos (por ordem de criação) */}
                {activityTab === 'agendamentos' && (
                  atividadeAgendamentos.length === 0
                    ? <p style={{ fontSize: '12px', color: '#8f8f8f', textAlign: 'center', padding: '12px 0', margin: 0 }}>Nenhum agendamento encontrado.</p>
                    : atividadeAgendamentos.map((a, i) => (
                        <div key={a.id || i} onClick={() => setDetalhesSelecionado(a)} style={{ display: 'flex', gap: '10px', padding: '8px 0', borderBottom: i < atividadeAgendamentos.length - 1 ? '0.5px solid #1e1e1e' : 'none', cursor: 'pointer', alignItems: 'flex-start' }}>
                          <div style={{ width: '7px', height: '7px', borderRadius: '50%', backgroundColor: a.status === 'confirmado' ? '#7bc47b' : a.status === 'pendente' ? '#c9a84c' : '#555', marginTop: '4px', flexShrink: 0 }} />
                          <div style={{ flex: 1 }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2px' }}>
                              <span style={{ fontSize: '12px', color: '#e8e8e8', fontWeight: '500' }}>{a.clienteNome || a.cliente || '—'}</span>
                              <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                                {a.tipo === 'manual' && <span style={{ fontSize: '8px', color: '#aeaeae', border: '0.5px solid #333', borderRadius: '3px', padding: '1px 4px' }}>manual</span>}
                                <span style={{ fontSize: '10px', color: a.status === 'confirmado' ? '#7bc47b' : a.status === 'pendente' ? '#c9a84c' : '#888' }}>{a.status === 'confirmado' ? 'conf.' : a.status === 'pendente' ? 'pend.' : a.status}</span>
                              </div>
                            </div>
                            <div style={{ fontSize: '11px', color: '#aeaeae', marginBottom: '1px' }}>{fmtApptDia(a)} · {a.horario}</div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <span style={{ fontSize: '10px', color: '#8f8f8f' }}>{a.servico} · {a.barbeiro}</span>
                              <span style={{ fontSize: '9px', color: '#7d7d7d' }}>{relativeTime(a.criadoEm)}</span>
                            </div>
                          </div>
                        </div>
                      ))
                )}

                {/* Aba: Cancelamentos */}
                {activityTab === 'cancelamentos' && (
                  atividadeCancelamentos.length === 0
                    ? <p style={{ fontSize: '12px', color: '#8f8f8f', textAlign: 'center', padding: '12px 0', margin: 0 }}>Nenhum cancelamento.</p>
                    : atividadeCancelamentos.map((a, i) => (
                        <div key={a.id || i} onClick={() => setDetalhesSelecionado(a)} style={{ display: 'flex', gap: '10px', padding: '8px 0', borderBottom: i < atividadeCancelamentos.length - 1 ? '0.5px solid #1e1e1e' : 'none', cursor: 'pointer', alignItems: 'flex-start' }}>
                          <div style={{ width: '7px', height: '7px', borderRadius: '50%', backgroundColor: '#e05555', marginTop: '4px', flexShrink: 0 }} />
                          <div style={{ flex: 1 }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2px' }}>
                              <span style={{ fontSize: '12px', color: '#e8e8e8', fontWeight: '500' }}>{a.clienteNome || a.cliente || '—'}</span>
                              <span style={{ fontSize: '9px', color: '#7d7d7d' }}>{relativeTime(a.criadoEm)}</span>
                            </div>
                            <div style={{ fontSize: '11px', color: '#aeaeae', marginBottom: '1px' }}>{fmtApptDia(a)} · {a.horario}</div>
                            <div style={{ fontSize: '10px', color: '#8f8f8f' }}>{a.servico} · {a.barbeiro}</div>
                          </div>
                        </div>
                      ))
                )}
              </div>

              {/* Logout */}
              <button
                onClick={async () => {
                  try { await performLogout(); } catch (_) {}
                  if (onLogout) onLogout();
                }}
                style={{
                  width: '100%', backgroundColor: '#1a0a0a', color: '#e05555',
                  border: '0.5px solid #4a1a1a', borderRadius: '12px',
                  padding: '13px', fontSize: '13px', fontWeight: '600',
                  cursor: 'pointer', fontFamily: 'Arial, sans-serif'
                }}
              >
                Sair da conta
              </button>
            </>
          )}

          {homeTab === 'ofertas' && (
            <>
              <div style={{ fontSize: '11px', color: '#aeaeae', marginBottom: '12px', lineHeight: '1.5' }}>Produtos e equipamentos selecionados para barbearias. Entrega direta.</div>
              {[
                { icon: '✂️', nome: 'Kit Tesouras Profissional', desc: 'Aço inox 6.5" — corte e texturização', preco: 'R$ 189,00' },
                { icon: '🔌', nome: 'Máquina de Corte Wahl', desc: '5 estrelas — bivolt, sem fio', preco: 'R$ 349,00' },
                { icon: '🧴', nome: 'Pomada Matte Barber Pro', desc: '120g · Fixação forte · Kit 6 unid.', preco: 'R$ 97,00' },
                { icon: '🪑', nome: 'Cadeira Reclinável Vintage', desc: 'Couro sintético preto — entrega SP/RS', preco: 'R$ 1.290,00' },
              ].map((p, i) => (
                <div key={i} style={{ ...ST.card, display: 'flex', gap: '10px', alignItems: 'flex-start' }}>
                  <div style={{ fontSize: '22px', flexShrink: 0 }}>{p.icon}</div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '13px', fontWeight: '600', color: '#e8e8e8', marginBottom: '2px' }}>{p.nome}</div>
                    <div style={{ fontSize: '11px', color: '#aeaeae', lineHeight: '1.4', marginBottom: '5px' }}>{p.desc}</div>
                    <div style={{ fontSize: '13px', color: '#c9a84c', fontWeight: '600' }}>{p.preco}</div>
                  </div>
                  <button style={{ fontSize: '10px', fontWeight: '600', color: '#7bc47b', border: '0.5px solid #2d4a2d', backgroundColor: 'transparent', borderRadius: '20px', padding: '3px 9px', cursor: 'pointer', fontFamily: 'Arial, sans-serif', flexShrink: 0 }}>Ver</button>
                </div>
              ))}
            </>
          )}
        </div>
      )}

      {/* ══ AGENDA ══ */}
      {aba === 'agenda' && (
        <>
          {renderCalendario()}
          {renderAgenda()}
        </>
      )}

      {/* ══ CLIENTES ══ */}
      {aba === 'clientes' && (
        <div style={{ padding: '14px 16px' }}>
          {clienteDetalhe ? (
            <>
              <button onClick={() => setClienteDetalhe(null)} style={{ display: 'flex', alignItems: 'center', gap: '5px', color: '#7bc47b', fontSize: '12px', fontWeight: '500', cursor: 'pointer', border: 'none', background: 'transparent', padding: '0 0 12px', fontFamily: 'Arial, sans-serif' }}>← voltar</button>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '14px' }}>
                <Av nome={clienteDetalhe.nome} size={46} />
                <div>
                  <div style={{ fontSize: '17px', fontWeight: '700', color: '#e8e8e8' }}>{clienteDetalhe.nome}</div>
                  <div style={{ fontSize: '12px', color: '#aeaeae', marginTop: '2px' }}>{clienteDetalhe.telefone}</div>
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '9px', marginBottom: '12px' }}>
                <div style={{ ...ST.card, marginBottom: 0, textAlign: 'center' }}>
                  <div style={{ fontSize: '24px', fontWeight: '700', color: '#e8e8e8' }}>{clienteDetalhe.visitas}</div>
                  <div style={{ fontSize: '10px', color: '#aeaeae' }}>visitas</div>
                </div>
                <div style={{ ...ST.card, marginBottom: 0, textAlign: 'center' }}>
                  <div style={{ fontSize: '24px', fontWeight: '700', color: '#6ab0e8' }}>0</div>
                  <div style={{ fontSize: '10px', color: '#aeaeae' }}>créditos</div>
                </div>
              </div>
              <div style={{ fontSize: '10px', color: '#aeaeae', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '8px' }}>Histórico</div>
              {clienteDetalhe.historico.sort((a, b) => (b.criadoEm || '').localeCompare(a.criadoEm || '')).map((h, i) => (
                <div key={i} style={{ ...ST.row, padding: '8px 0', borderBottom: '0.5px solid #1e1e1e' }}>
                  <div>
                    <div style={{ fontSize: '12px', color: '#e8e8e8', fontWeight: '500' }}>{h.servico}</div>
                    <div style={{ fontSize: '11px', color: '#aeaeae', marginTop: '1px' }}>Dia {h.dia} · {h.horario} · {h.barbeiro}</div>
                  </div>
                  <span style={{ fontSize: '13px', color: '#7bc47b', fontWeight: '600' }}>{h.preco}</span>
                </div>
              ))}
            </>
          ) : (
            <>
              <input placeholder="Buscar cliente..." style={{ ...ST.inp, marginBottom: '12px' }} />
              {clientesList.length === 0 && <p style={{ color: '#8f8f8f', textAlign: 'center', padding: '30px 0', fontSize: '13px' }}>Nenhum cliente ainda.</p>}
              {clientesList.slice(0, 3).length > 0 && <div style={{ fontSize: '10px', color: '#aeaeae', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '7px' }}>Frequentes</div>}
              {clientesList.slice(0, 3).map((c, i) => (
                <div key={i} onClick={() => setClienteDetalhe(c)} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '9px 0', borderBottom: '0.5px solid #1e1e1e', cursor: 'pointer' }}>
                  <Av nome={c.nome} />
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '13px', color: '#e8e8e8', fontWeight: '500' }}>{c.nome} {c.visitas >= 5 && <span style={ST.tag('#2a2010', '#c9a84c', '#4a3a1a')}>fiel</span>}</div>
                    <div style={{ fontSize: '11px', color: '#aeaeae', marginTop: '1px' }}>{c.telefone}</div>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: '16px', color: '#c9a84c', fontWeight: '700' }}>{c.visitas}</div>
                    <div style={{ fontSize: '10px', color: '#a6a6a6' }}>visitas</div>
                  </div>
                </div>
              ))}
              {clientesList.length > 3 && (
                <>
                  <div style={{ fontSize: '10px', color: '#aeaeae', textTransform: 'uppercase', letterSpacing: '1px', margin: '12px 0 7px' }}>Todos</div>
                  {clientesList.slice(3).map((c, i) => (
                    <div key={i} onClick={() => setClienteDetalhe(c)} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '9px 0', borderBottom: '0.5px solid #1e1e1e', cursor: 'pointer' }}>
                      <Av nome={c.nome} bg='#1c2a3a' col='#6ab0e8' />
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: '13px', color: '#e8e8e8', fontWeight: '500' }}>{c.nome}</div>
                        <div style={{ fontSize: '11px', color: '#aeaeae', marginTop: '1px' }}>{c.telefone}</div>
                      </div>
                      <div style={{ textAlign: 'right' }}>
                        <div style={{ fontSize: '14px', color: '#7bc47b', fontWeight: '600' }}>{c.visitas}</div>
                        <div style={{ fontSize: '10px', color: '#a6a6a6' }}>visitas</div>
                      </div>
                    </div>
                  ))}
                </>
              )}
            </>
          )}
        </div>
      )}

      {/* ══ EXTRATO ══ */}
      {aba === 'extrato' && (
        <div style={{ padding: '14px 16px' }}>
          <div style={ST.stb}>
            <button style={ST.stbBtn(extTab === 'diario')} onClick={() => setExtTab('diario')}>Diário</button>
            <button style={ST.stbBtn(extTab === 'mensal')} onClick={() => setExtTab('mensal')}>Mensal</button>
          </div>

          {/* Filtro barbeiro */}
          <div style={{ display: 'flex', gap: '6px', marginBottom: '12px', flexWrap: 'wrap' }}>
            {['todos', ...barbeirosLista].map(b => (
              <button key={b} onClick={() => setFiltroExtBarbeiro(b)} style={ST.pill(filtroExtBarbeiro === b)}>
                {b === 'todos' ? 'Todos' : b.split(' ')[0]}
              </button>
            ))}
          </div>

          {extTab === 'diario' && (
            <>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
                <button onClick={() => { const d = new Date(extratoData); d.setDate(d.getDate() - 1); setExtratoData(d); }} style={{ fontSize: '22px', color: '#7bc47b', background: 'transparent', border: 'none', cursor: 'pointer', padding: '0 8px' }}>‹</button>
                <span style={{ fontSize: '13px', color: '#e8e8e8', fontWeight: '500' }}>{extratoData.toLocaleDateString('pt-BR', { weekday: 'short', day: '2-digit', month: 'short', year: 'numeric' })}</span>
                <button onClick={() => { const d = new Date(extratoData); d.setDate(d.getDate() + 1); setExtratoData(d); }} style={{ fontSize: '22px', color: '#7bc47b', background: 'transparent', border: 'none', cursor: 'pointer', padding: '0 8px' }}>›</button>
              </div>

              <div onClick={() => setModal({ tipo: 'breakdown-dia' })} style={{ ...ST.greenCard, cursor: 'pointer' }}>
                <div style={{ fontSize: '10px', color: '#2d5a2d', marginBottom: '2px' }}>toque para detalhar</div>
                <div style={{ fontSize: '26px', fontWeight: '700', color: '#7bc47b' }}>{fmtR(finExtDia.liquido)}</div>
                <div style={{ fontSize: '10px', color: '#2d5a2d', marginTop: '2px' }}>receita líquida · {extratoData.toLocaleDateString('pt-BR')}</div>
              </div>

              {Object.keys(porHora).length > 0 ? (
                <>
                  <div style={{ fontSize: '10px', color: '#aeaeae', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '8px' }}>Por hora</div>
                  {Object.entries(porHora).sort().map(([hora, items]) => {
                    const totHora = items.reduce((s, a) => s + parsePreco(a.preco), 0);
                    return (
                      <div key={hora} onClick={() => setModal({ tipo: 'hora-detalhe', dados: { hora, items } })}
                        style={{ ...ST.card, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <span style={{ fontSize: '13px', fontWeight: '600', color: '#7bc47b', minWidth: '30px', fontFamily: 'monospace' }}>{hora}</span>
                        <div style={{ display: 'flex' }}>
                          {items.slice(0, 3).map((a, i) => (
                            <div key={i} style={{ width: '26px', height: '26px', borderRadius: '50%', backgroundColor: `hsl(${(((a.clienteNome || a.cliente) || '').charCodeAt(0) * 7) % 360},30%,25%)`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '9px', fontWeight: '600', color: '#e8e8e8', marginLeft: i > 0 ? '-6px' : 0, border: '1.5px solid #181818' }}>
                              {iniciais(a.clienteNome || a.cliente)}
                            </div>
                          ))}
                        </div>
                        <span style={{ fontSize: '11px', color: '#aeaeae' }}>{items.length} atend.</span>
                        <span style={{ fontSize: '13px', color: '#e8e8e8', fontWeight: '600', marginLeft: 'auto' }}>{fmtR(totHora)}</span>
                        <span style={{ color: '#8f8f8f', fontSize: '14px' }}>›</span>
                      </div>
                    );
                  })}
                </>
              ) : (
                <p style={{ color: '#8f8f8f', textAlign: 'center', padding: '24px 0', fontSize: '13px' }}>Nenhum atendimento neste dia.</p>
              )}
            </>
          )}

          {extTab === 'mensal' && (
            <>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
                <button onClick={() => { const d = new Date(extratoMes); d.setMonth(d.getMonth() - 1); setExtratoMes(d); }} style={{ fontSize: '22px', color: '#7bc47b', background: 'transparent', border: 'none', cursor: 'pointer', padding: '0 8px' }}>‹</button>
                <span style={{ fontSize: '13px', color: '#e8e8e8', fontWeight: '500', textTransform: 'capitalize' }}>{extratoMes.toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' })}</span>
                <button onClick={() => { const d = new Date(extratoMes); d.setMonth(d.getMonth() + 1); if (d.getFullYear() < hoje.getFullYear() || (d.getFullYear() === hoje.getFullYear() && d.getMonth() <= hoje.getMonth())) setExtratoMes(d); }} style={{ fontSize: '22px', color: '#7bc47b', background: 'transparent', border: 'none', cursor: 'pointer', padding: '0 8px' }}>›</button>
              </div>

              <div onClick={() => setModal({ tipo: 'breakdown-mes' })} style={{ ...ST.greenCard, cursor: 'pointer' }}>
                <div style={{ fontSize: '10px', color: '#2d5a2d', marginBottom: '2px' }}>toque para detalhar</div>
                <div style={{ fontSize: '26px', fontWeight: '700', color: '#7bc47b' }}>{fmtR(finExtMes.liquido)}</div>
                <div style={{ fontSize: '10px', color: '#2d5a2d', marginTop: '2px' }}>receita líquida · {extratoMes.toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' })}</div>
              </div>

              <div style={ST.card}>
                <div style={{ fontSize: '10px', color: '#aeaeae', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '10px' }}>Calendário de receita</div>
                {renderCalExtrato()}
              </div>

              <div style={ST.card}>
                <div style={{ fontSize: '10px', color: '#7bc47b', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '10px', fontWeight: '600' }}>Resumo do mês</div>
                {[
                  { l: 'Total de atendimentos', v: finExtMes.count },
                  { l: 'Ticket médio', v: fmtR(ticketMedio) },
                  { l: 'Média de atend. por dia', v: mediaDiaria.toFixed(1) },
                  { l: 'Dia mais movimentado', v: diaMaisMovim },
                  { l: 'Faturamento bruto', v: fmtR(finExtMes.bruto) },
                  { l: 'Taxa de conveniência', v: `-${fmtR(finExtMes.taxa)}`, c: '#555' },
                ].map((r, i) => (
                  <div key={i} style={{ ...ST.row, padding: '7px 0', borderBottom: '0.5px solid #1e1e1e' }}>
                    <span style={{ fontSize: '12px', color: '#aeaeae' }}>{r.l}</span>
                    <span style={{ fontSize: '12px', color: r.c || '#e8e8e8', fontWeight: '500' }}>{r.v}</span>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      )}

      {/* ══ CONFIG ══ */}
      {aba === 'config' && (
        <div style={{ padding: '14px 16px' }}>
          <div style={ST.stb}>
            <button style={ST.stbBtn(cfgTab === 'barbeiros')} onClick={() => setCfgTab('barbeiros')}>Barbeiros</button>
            <button style={ST.stbBtn(cfgTab === 'servicos')} onClick={() => setCfgTab('servicos')}>Serviços</button>
            <button style={ST.stbBtn(cfgTab === 'promocoes')} onClick={() => setCfgTab('promocoes')}>Promoções</button>
            <button style={ST.stbBtn(cfgTab === 'notif')} onClick={() => setCfgTab('notif')}>Notif.</button>
            <button style={ST.stbBtn(cfgTab === 'perfil')} onClick={() => setCfgTab('perfil')}>Perfil</button>
          </div>

          {cfgTab === 'barbeiros' && (
            <>
              {(barbearia?.barbeiros || []).map((b, i) => (
                <div key={i} style={ST.card}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: '#2d4a2d', overflow: 'hidden', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '13px', color: '#7bc47b', fontWeight: '600' }}>
                      {b.foto ? <img src={b.foto} alt={b.nome} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : iniciais(b.nome)}
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '14px', color: '#e8e8e8', fontWeight: '500' }}>{b.nome}</div>
                      <div style={{ fontSize: '11px', color: '#aeaeae', marginTop: '1px' }}>barbeiro</div>
                    </div>
                    <span style={ST.tag('#1e3320', '#7bc47b', '#2d4a2d')}>ativo</span>
                    <button onClick={() => setModal({ tipo: 'excluir-barbeiro', dados: { nome: b.nome } })} style={{ fontSize: '11px', color: '#e05555', background: 'transparent', border: '0.5px solid #3d1a1a', borderRadius: '6px', padding: '3px 8px', cursor: 'pointer', fontFamily: 'Arial, sans-serif' }}>excluir</button>
                  </div>
                  <div style={{ fontSize: '10px', color: '#aeaeae', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '6px' }}>Horário de trabalho</div>
                  <div style={{ display: 'flex', gap: '3px', marginBottom: '7px' }}>
                    {['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom'].map(d => {
                      const hp = b.horariosPorDia || {};
                      const trabalha = hp[d]?.length > 0 || (b.diasTrabalho || []).includes(d);
                      return (
                        <div key={d} style={{ width: '29px', height: '23px', borderRadius: '5px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '9px', fontWeight: '600', backgroundColor: trabalha ? '#2d4a2d' : '#1c1c1c', color: trabalha ? '#7bc47b' : '#444' }}>{d}</div>
                      );
                    })}
                  </div>
                  {(() => {
                    const hp = b.horariosPorDia;
                    if (hp && Object.keys(hp).length > 0) {
                      return ['Seg','Ter','Qua','Qui','Sex','Sáb','Dom'].filter(d => hp[d]?.length > 0).map(d => (
                        <div key={d} style={{ fontSize: '11px', color: '#aeaeae', marginBottom: '1px' }}>
                          <span style={{ color: '#8f8f8f', minWidth: '28px', display: 'inline-block' }}>{d}</span>
                          {(hp[d] || []).map(p => `${p.inicio}–${p.fim}`).join('  ·  ')}
                        </div>
                      ));
                    }
                    return <div style={{ fontSize: '11px', color: '#aeaeae' }}>{b.horaInicio || '09:00'} às {b.horaFim || '19:00'}</div>;
                  })()}
                </div>
              ))}
              {(!barbearia?.barbeiros || barbearia.barbeiros.length === 0) && (
                <p style={{ color: '#8f8f8f', textAlign: 'center', padding: '24px 0', fontSize: '13px' }}>Nenhum barbeiro cadastrado.<br />Acesse o Perfil para adicionar.</p>
              )}
              <button onClick={() => setCfgTab('perfil')} style={{ width: '100%', padding: '11px', borderRadius: '9px', border: '0.5px dashed #333', backgroundColor: 'transparent', color: '#a6a6a6', fontSize: '12px', fontWeight: '500', cursor: 'pointer', fontFamily: 'Arial, sans-serif', marginTop: '4px' }}>+ adicionar barbeiro (via Perfil)</button>
            </>
          )}

          {cfgTab === 'servicos' && (
            <>
              <div style={{ fontSize: '10px', color: '#aeaeae', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '8px' }}>Serviços ativos</div>
              {servicosLista.map((s, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '9px 0', borderBottom: '0.5px solid #1e1e1e' }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '13px', color: '#e8e8e8', fontWeight: '500' }}>{s.nome}</div>
                    <div style={{ fontSize: '11px', color: '#aeaeae', marginTop: '1px' }}>{s.duracao} min</div>
                  </div>
                  <span style={{ fontSize: '14px', color: '#7bc47b', fontWeight: '600' }}>{s.preco}</span>
                </div>
              ))}
              {servicosLista.length === 0 && <p style={{ color: '#8f8f8f', textAlign: 'center', padding: '24px 0', fontSize: '13px' }}>Nenhum serviço cadastrado.<br />Acesse o Perfil para adicionar.</p>}
              <button onClick={() => setCfgTab('perfil')} style={{ width: '100%', padding: '11px', borderRadius: '9px', border: '0.5px dashed #333', backgroundColor: 'transparent', color: '#a6a6a6', fontSize: '12px', fontWeight: '500', cursor: 'pointer', fontFamily: 'Arial, sans-serif', marginTop: '10px' }}>+ adicionar serviço (via Perfil)</button>
            </>
          )}

          {cfgTab === 'promocoes' && (
            <>
              {/* Helper visual: toggle inline */}
              {[
                {
                  tipo: 'simples', icon: '🏷️', titulo: 'Desconto direto',
                  desc: promSimples.ativa
                    ? (promSimples.desconto > 0 ? `${promSimples.desconto}% off em todos os serviços` : 'Configure o desconto abaixo')
                    : 'Desconto fixo em todos os serviços',
                  estado: promSimples, setEstado: setPromSimples,
                },
                {
                  tipo: 'dias', icon: '📅', titulo: 'Desconto por dia',
                  desc: promDias.ativa
                    ? (promDias.diasSemana?.length > 0
                        ? `${promDias.desconto}% off toda ${['Dom','Seg','Ter','Qua','Qui','Sex','Sáb'].filter((_,i)=>promDias.diasSemana.includes(i)).join(', ')}`
                        : 'Selecione os dias abaixo')
                    : 'Desconto em dias específicos da semana',
                  estado: promDias, setEstado: setPromDias,
                },
                {
                  tipo: 'fidelidade', icon: '⭐', titulo: 'Fidelidade',
                  desc: promFidelidade.ativa
                    ? `Grátis a cada ${promFidelidade.fidelidadeMeta} visitas`
                    : 'Cliente ganha 1 grátis a cada N visitas',
                  estado: promFidelidade, setEstado: setPromFidelidade,
                },
              ].map(({ tipo, icon, titulo, desc, estado, setEstado }) => {
                // Fidelidade ainda não disponível — card bloqueado
                if (tipo === 'fidelidade') {
                  return (
                    <div key={tipo} style={{ marginBottom: '10px', borderRadius: '12px', border: '0.5px solid #252525', backgroundColor: '#141414', overflow: 'hidden', opacity: 0.7 }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 14px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          <span style={{ fontSize: '16px' }}>{icon}</span>
                          <div>
                            <div style={{ fontSize: '13px', color: '#aeaeae', fontWeight: '600' }}>{titulo}</div>
                            <div style={{ fontSize: '11px', color: '#7d7d7d', marginTop: '1px' }}>Este serviço ainda não está disponível</div>
                          </div>
                        </div>
                        <span style={{ fontSize: '10px', color: '#7d7d7d', backgroundColor: '#1e1e1e', border: '0.5px solid #2a2a2a', borderRadius: '6px', padding: '3px 7px' }}>Em breve</span>
                      </div>
                    </div>
                  );
                }
                return (
                <div key={tipo} style={{ marginBottom: '10px', borderRadius: '12px', border: `0.5px solid ${estado.ativa ? '#2d4a2d' : '#252525'}`, backgroundColor: estado.ativa ? '#0f1a0f' : '#181818', overflow: 'hidden' }}>
                  {/* Cabeçalho do card */}
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 14px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <span style={{ fontSize: '16px' }}>{icon}</span>
                      <div>
                        <div style={{ fontSize: '13px', color: '#e8e8e8', fontWeight: '600' }}>{titulo}</div>
                        <div style={{ fontSize: '11px', color: estado.ativa ? '#7bc47b' : '#555', marginTop: '1px' }}>{desc}</div>
                      </div>
                    </div>
                    {/* Toggle */}
                    <div
                      onClick={() => !salvandoConfig && toggleTipo(tipo, !estado.ativa)}
                      style={{ width: '42px', height: '24px', borderRadius: '12px', backgroundColor: estado.ativa ? '#2d4a2d' : '#2a2a2a', position: 'relative', cursor: salvandoConfig ? 'default' : 'pointer', transition: 'background 0.2s', flexShrink: 0 }}
                    >
                      <div style={{ width: '18px', height: '18px', borderRadius: '50%', backgroundColor: estado.ativa ? '#7bc47b' : '#555', position: 'absolute', top: '3px', left: estado.ativa ? '21px' : '3px', transition: 'left 0.2s' }} />
                    </div>
                  </div>

                  {/* Config expandida quando ativo */}
                  {estado.ativa && (
                    <div style={{ padding: '0 14px 14px', borderTop: '0.5px solid #1e2e1e' }}>
                      <div style={{ height: '10px' }} />

                      {/* Simples */}
                      {tipo === 'simples' && (
                        <>
                          <div style={{ fontSize: '10px', color: '#9c9c9c', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '8px' }}>Desconto</div>
                          <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginBottom: '12px' }}>
                            {[10, 15, 20, 25, 30].map(p => (
                              <button key={p} onClick={() => setEstado(prev => ({ ...prev, desconto: p }))}
                                style={{ padding: '6px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '600', border: `0.5px solid ${estado.desconto === p ? '#c9a84c' : '#333'}`, backgroundColor: estado.desconto === p ? '#2a1a05' : 'transparent', color: estado.desconto === p ? '#c9a84c' : '#666', cursor: 'pointer', fontFamily: 'Arial, sans-serif' }}>
                                {p}%
                              </button>
                            ))}
                          </div>
                          {estado.desconto > 0 && servicosLista.length > 0 && (
                            <div style={{ backgroundColor: '#1a1209', border: '0.5px solid #3a2a10', borderRadius: '10px', padding: '10px 14px', marginBottom: '12px' }}>
                              <div style={{ fontSize: '10px', color: '#9c9c9c', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '8px' }}>Prévia</div>
                              {servicosLista.map((s, i) => {
                                const n = parsePreco(s.preco);
                                const d = Math.round(n * (1 - estado.desconto / 100) * 100) / 100;
                                return (
                                  <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '3px 0' }}>
                                    <span style={{ fontSize: '12px', color: '#aeaeae' }}>{s.nome}</span>
                                    <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                                      <span style={{ fontSize: '11px', color: '#7d7d7d', textDecoration: 'line-through' }}>{s.preco}</span>
                                      <span style={{ fontSize: '13px', color: '#c9a84c', fontWeight: '600' }}>{fmtR(d)}</span>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </>
                      )}

                      {/* Dias */}
                      {tipo === 'dias' && (
                        <>
                          <div style={{ fontSize: '10px', color: '#9c9c9c', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '8px' }}>Dias com desconto</div>
                          <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginBottom: '12px' }}>
                            {['Dom','Seg','Ter','Qua','Qui','Sex','Sáb'].map((d, i) => {
                              const sel = (estado.diasSemana || []).includes(i);
                              return (
                                <button key={i}
                                  onClick={() => setEstado(prev => ({ ...prev, diasSemana: sel ? prev.diasSemana.filter(x => x !== i) : [...(prev.diasSemana||[]), i] }))}
                                  style={{ padding: '6px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '600', border: `0.5px solid ${sel ? '#2d4a2d' : '#333'}`, backgroundColor: sel ? '#1a2a1a' : 'transparent', color: sel ? '#7bc47b' : '#555', cursor: 'pointer', fontFamily: 'Arial, sans-serif' }}>
                                  {d}
                                </button>
                              );
                            })}
                          </div>
                          <div style={{ fontSize: '10px', color: '#9c9c9c', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '8px' }}>Desconto nesses dias</div>
                          <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginBottom: '12px' }}>
                            {[10, 15, 20, 25, 30].map(p => (
                              <button key={p} onClick={() => setEstado(prev => ({ ...prev, desconto: p }))}
                                style={{ padding: '6px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '600', border: `0.5px solid ${estado.desconto === p ? '#c9a84c' : '#333'}`, backgroundColor: estado.desconto === p ? '#2a1a05' : 'transparent', color: estado.desconto === p ? '#c9a84c' : '#666', cursor: 'pointer', fontFamily: 'Arial, sans-serif' }}>
                                {p}%
                              </button>
                            ))}
                          </div>
                        </>
                      )}

                      {/* Fidelidade */}
                      {tipo === 'fidelidade' && (
                        <>
                          <div style={{ fontSize: '10px', color: '#9c9c9c', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '8px' }}>Visitas para ganhar 1 grátis</div>
                          <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginBottom: '12px' }}>
                            {[5, 8, 10, 12, 15].map(n => (
                              <button key={n} onClick={() => setEstado(prev => ({ ...prev, fidelidadeMeta: n }))}
                                style={{ padding: '6px 14px', borderRadius: '20px', fontSize: '12px', fontWeight: '600', border: `0.5px solid ${estado.fidelidadeMeta === n ? '#c9a84c' : '#333'}`, backgroundColor: estado.fidelidadeMeta === n ? '#2a1a05' : 'transparent', color: estado.fidelidadeMeta === n ? '#c9a84c' : '#666', cursor: 'pointer', fontFamily: 'Arial, sans-serif' }}>
                                {n}
                              </button>
                            ))}
                          </div>
                          <div style={{ backgroundColor: '#1a1209', border: '0.5px solid #3a2a10', borderRadius: '10px', padding: '10px 14px', marginBottom: '12px' }}>
                            <div style={{ fontSize: '12px', color: '#c9a84c', lineHeight: '1.6' }}>
                              A cada <strong>{estado.fidelidadeMeta}</strong> visitas o cliente ganha o próximo serviço grátis automaticamente.
                            </div>
                          </div>
                        </>
                      )}

                      {/* Texto do banner */}
                      <div style={{ fontSize: '10px', color: '#9c9c9c', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '6px' }}>Texto do banner (opcional)</div>
                      <input
                        value={estado.texto || ''}
                        onChange={e => setEstado(prev => ({ ...prev, texto: e.target.value.slice(0, 40) }))}
                        placeholder={
                          tipo === 'fidelidade' ? `Ex: Ganhe 1 grátis a cada ${estado.fidelidadeMeta} visitas!`
                          : tipo === 'dias' && estado.desconto > 0 ? `Ex: ${estado.desconto}% off toda semana!`
                          : estado.desconto > 0 ? `Ex: ${estado.desconto}% off essa semana!`
                          : 'Ex: Promoção especial!'
                        }
                        maxLength={40}
                        style={{ ...ST.inp, marginBottom: '4px' }}
                      />
                      <div style={{ fontSize: '10px', color: '#7d7d7d', textAlign: 'right', marginBottom: '10px' }}>{(estado.texto || '').length}/40</div>
                      <button
                        onClick={() => salvarTipo(tipo)}
                        disabled={salvandoConfig}
                        style={{ width: '100%', padding: '10px', borderRadius: '9px', border: '0.5px solid #2d4a2d', backgroundColor: '#1a2a1a', color: '#7bc47b', fontSize: '12px', fontWeight: '600', cursor: salvandoConfig ? 'not-allowed' : 'pointer', fontFamily: 'Arial, sans-serif', opacity: salvandoConfig ? 0.6 : 1 }}
                      >
                        {salvandoConfig ? 'Salvando...' : 'Salvar'}
                      </button>
                    </div>
                  )}
                </div>
              );
              })}
            </>
          )}

          {cfgTab === 'notif' && (
            <>
              {/* Toggle de aprovação manual */}
              <div style={{ fontSize: '10px', color: '#aeaeae', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '12px' }}>Agendamentos</div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 14px', backgroundColor: barbearia?.exigeAprovacao ? '#141f14' : '#181818', border: `0.5px solid ${barbearia?.exigeAprovacao ? '#2d4a2d' : '#252525'}`, borderRadius: '12px', marginBottom: '16px' }}>
                <div>
                  <div style={{ fontSize: '13px', color: '#e8e8e8', fontWeight: '600' }}>Exigir aprovação manual</div>
                  <div style={{ fontSize: '11px', color: '#8f8f8f', marginTop: '2px' }}>Novos agendamentos ficam pendentes até você aprovar</div>
                </div>
                <div
                  onClick={() => !salvandoConfig && toggleAprovacao(!barbearia?.exigeAprovacao)}
                  style={{ width: '42px', height: '24px', borderRadius: '12px', backgroundColor: barbearia?.exigeAprovacao ? '#2d4a2d' : '#2a2a2a', position: 'relative', cursor: salvandoConfig ? 'default' : 'pointer', transition: 'background 0.2s', flexShrink: 0 }}
                >
                  <div style={{ width: '18px', height: '18px', borderRadius: '50%', backgroundColor: barbearia?.exigeAprovacao ? '#7bc47b' : '#555', position: 'absolute', top: '3px', left: barbearia?.exigeAprovacao ? '21px' : '3px', transition: 'left 0.2s' }} />
                </div>
              </div>
              {/* Link de agendamento — para bio do Instagram */}
              <div style={{ fontSize: '10px', color: '#aeaeae', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '8px', marginTop: '4px' }}>Link de agendamento</div>
              <div style={{ backgroundColor: '#181818', border: '0.5px solid #252525', borderRadius: '10px', padding: '12px 14px', marginBottom: '16px' }}>
                <div style={{ fontSize: '13px', color: '#e8e8e8', fontWeight: '500', marginBottom: '4px' }}>Seu link exclusivo</div>
                <div style={{ fontSize: '11px', color: '#aeaeae', lineHeight: '1.6', marginBottom: '10px' }}>
                  Compartilhe na bio do Instagram ou no WhatsApp. Quando o cliente clicar, cai direto na escolha do barbeiro da sua barbearia.
                </div>
                {barbearia?.slug ? (
                  <>
                    <div style={{ backgroundColor: '#111', border: '0.5px solid #2d4a2d', borderRadius: '8px', padding: '8px 10px', marginBottom: '10px', wordBreak: 'break-all' }}>
                      <span style={{ fontSize: '11px', color: '#7bc47b', fontFamily: 'monospace' }}>
                        {`${window.location.origin}/${barbearia.slug}`}
                      </span>
                    </div>
                    <button
                      onClick={() => {
                        const link = `${window.location.origin}/${barbearia.slug}`;
                        navigator.clipboard.writeText(link).then(() => {
                          alert('Link copiado!');
                        }).catch(() => {
                          const el = document.createElement('textarea');
                          el.value = link;
                          document.body.appendChild(el);
                          el.select();
                          document.execCommand('copy');
                          document.body.removeChild(el);
                          alert('Link copiado!');
                        });
                      }}
                      style={{
                        width: '100%', backgroundColor: '#1a2a1a', color: '#7bc47b',
                        border: '0.5px solid #2d4a2d', borderRadius: '8px',
                        padding: '9px', fontSize: '12px', fontWeight: '600',
                        cursor: 'pointer', fontFamily: 'Arial, sans-serif'
                      }}
                    >
                      Copiar link
                    </button>
                  </>
                ) : (
                  <div style={{ backgroundColor: '#1a1a0f', border: '0.5px solid #3a3a20', borderRadius: '8px', padding: '10px 12px', fontSize: '12px', color: '#aeaeae', lineHeight: '1.6' }}>
                    Configure um <strong style={{ color: '#c9a84c' }}>endereço personalizado</strong> no seu perfil (aba Config → Perfil → "Link da barbearia") para ativar este recurso.
                  </div>
                )}
              </div>

              {/* WhatsApp — informativo */}
              <div style={{ fontSize: '10px', color: '#aeaeae', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '8px' }}>WhatsApp</div>
              <div style={{ backgroundColor: '#181818', border: '0.5px solid #252525', borderRadius: '10px', padding: '12px 14px' }}>
                <div style={{ fontSize: '13px', color: '#e8e8e8', fontWeight: '500', marginBottom: '4px' }}>Notificações via WhatsApp</div>
                <div style={{ fontSize: '11px', color: '#aeaeae', lineHeight: '1.6' }}>
                  Ao confirmar ou cancelar um agendamento, o botão <span style={{ color: '#25d366' }}>💬 Avisar no WhatsApp</span> abrirá uma mensagem pronta para enviar ao cliente.
                </div>
              </div>
            </>
          )}

          {cfgTab === 'perfil' && (
            <PerfilBarbearia
              barbearia={barbearia}
              onAtualizar={(dados) => setBarbearia(prev => ({
                ...prev,
                ...dados,
                nome: dados.nome?.trim() || prev?.nome, // protege contra nome vazio
              }))}
            />
          )}
        </div>
      )}

      {/* ══ BANNER PATROCINADO FIXO — só no home ══ */}
      {aba === 'home' && (
        <div style={{ position: 'fixed', bottom: '56px', left: '50%', transform: 'translateX(-50%)', width: 'calc(100% - 32px)', maxWidth: '448px', zIndex: 50, backgroundColor: '#141410', border: '0.5px solid #2a2a20', borderRadius: '12px', padding: '10px 14px', boxShadow: '0 -4px 20px rgba(0,0,0,0.5)' }}>
          <div style={{ fontSize: '9px', color: '#8f8f8f', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '4px' }}>Patrocinado</div>
          <div style={{ fontSize: '13px', color: '#e8e8e8', fontWeight: '600', marginBottom: '2px' }}>Produtos para sua barbearia</div>
          <div style={{ fontSize: '11px', color: '#aeaeae', lineHeight: '1.4' }}>Tesouras, máquinas e produtos profissionais com desconto exclusivo BLADE.</div>
        </div>
      )}

      {/* ══ BOTTOM BAR ══ */}
      <div style={{ position: 'fixed', bottom: 0, left: '50%', transform: 'translateX(-50%)', width: '100%', maxWidth: '480px', backgroundColor: '#0e0e0e', borderTop: '1px solid #1a1a1a', display: 'flex', zIndex: 100 }}>
        <BarBtn id="home" label="home">
          <rect x="3" y="3" width="7" height="7" rx="1.5" fill={aba === 'home' ? '#7bc47b' : 'none'} />
          <rect x="12" y="3" width="7" height="7" rx="1.5" opacity=".5" />
          <rect x="3" y="12" width="7" height="7" rx="1.5" opacity=".5" />
          <rect x="12" y="12" width="7" height="7" rx="1.5" opacity=".5" />
        </BarBtn>
        <BarBtn id="agenda" label="agenda">
          <rect x="3" y="4" width="16" height="15" rx="2" />
          <line x1="7" y1="2" x2="7" y2="6" />
          <line x1="15" y1="2" x2="15" y2="6" />
          <line x1="3" y1="9" x2="19" y2="9" />
        </BarBtn>
        <BarBtn id="clientes" label="clientes">
          <circle cx="11" cy="7.5" r="3.5" />
          <path d="M3 19c0-3.3 3.6-6 8-6s8 2.7 8 6" />
        </BarBtn>
        <BarBtn id="extrato" label="extrato">
          <rect x="3" y="4" width="16" height="15" rx="2" />
          <line x1="7" y1="10" x2="15" y2="10" />
          <line x1="7" y1="14" x2="12" y2="14" />
        </BarBtn>
        <BarBtn id="config" label="config">
          <circle cx="11" cy="11" r="3" />
          <path d="M11 2v2M11 18v2M2 11h2M18 11h2M4.93 4.93l1.41 1.41M15.66 15.66l1.41 1.41M4.93 17.07l1.41-1.41M15.66 6.34l1.41-1.41" />
        </BarBtn>
      </div>
    </div>
  );
}

export default PainelBarbearia;
